import React, { Component, createRef, forwardRef } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import Receipt from '../../../../../assets/images/module/general/ReceiptDummy.png';
import { Row, Col, Form, OverlayTrigger } from 'react-bootstrap';
import CustomModal from '.';
import { hideNotification, showNotification } from '@mantine/notifications';
import ColorButton from '../Buttons/ColorButton';
import CopyIcon from '../../../SVGs/copyIcon';
import GreenTick from '../../../../../assets/images/module/general/GreenTick.svg';
import RedTick from '../../../../../assets/images/module/general/RedTick.svg';
import RedCross from '../../../../../assets/images/module/general/RedCross.svg';
import { Checkbox, CloseButton, Group, Loader, Select, SimpleGrid, Stack, TextInput, Menu, NumberInput, Tooltip as MantineTooltip } from '@mantine/core';
import EmptyStateContainer from '../EmptyStateContainer/EmptyStateContainer';
import TenantIconBlue from '../../../../../assets/images/module/general/TenantIconBlue.svg';
import RentIconBlue from '../../../../../assets/images/module/general/RentIcon.svg';
import RentIconGreen from '../../../../../assets/images/module/general/RentIconGreen.svg';
import ReceiptsIcon from '../../../../../assets/images/module/general/ReceiptsIconGray.svg';
import RentIcon from '../../../../../assets/images/module/general/RentIconGray.svg';
import ReceiptsIconBlue from '../../../../../assets/images/module/general/ReceiptsIconBlue.svg';
import RightArrowPartner from '../../../../../assets/images/module/general/RightArrowPartner.svg';
import CloseButtonIcon from '../../../../../assets/images/module/general/CloseButtonIcon.svg';
import Up from '../../../../../assets/images/module/general/SelectArrowUp.svg';
import Down from '../../../../../assets/images/module/general/SelectArrowDown.svg';
import EmptyIcon from '../../../../../assets/images/EmptyReciept.svg';
import { NumericFormat } from 'react-number-format';
import CardSelection from '../CardSelection/CardSelection';
import { connect } from 'react-redux';
import { IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip } from '@material-ui/core';
import Autoload from '../../../../Autoload';
import dayjs from 'dayjs';
import accounting from 'accounting';
import SelectReceiptsForTransactionAssigmentModal from './SelectReceiptsForTransactionAssigmentModal';
import SwitchContainer from '../SwitchContainer';
import { push } from 'draft-js/lib/EditorState';
import ReceiptDetailModal from './ReceiptDetailModal';
import AddIcon from '@material-ui/icons/Add';
import ShowModal from './ShowModal';
import ImageModal from './ImageModal';
import LaunchIcon from '@material-ui/icons/Launch';
import GlobalServices from '../../../../helpers/services/GlobalServices';
import TenantDataHandler from '../../../../helpers/DataHandler/Tenant';
import costType from '../../../../../views/pages/Module/Property/costType';
import UtilityBillingAssignedIcon from '../../../SVGs/utilityBillingAssigned';
import TruncatedTextHandler from '../../../../../components/TruncatedTextHandler';
import AutoAssignReceiptTenantTransaction from './AutoAssignReceiptTenantTransaction';
import DeleteAllTransactionMappingConfirmationModal from './DeleteAllTransactionMappingConfirmationModal';
import ApplyMappingToLegacyTransactionsModal from './ApplyMappingToLegacyTransactionsModal';
import CustomMultiSelect from '../CustomMultiSelect/CustomMultSelect';
import { AI_AGENT_BASE_URL } from '../../../../../helpers/aiAgentApi';
import { isAiConsentAccepted } from '../../../../../helpers/aiConsent';
import AiAgentIcon from '../../../../../assets/images/module/general/AiAgentIcon.svg';
import { AddMappingButton, FIRST_ROW_HEIGHT, MappingConditionFields, MappingConditionSummary, TransactionMappingCard } from '../../../../../components/TransactionMappingCard';
import { TEXT_QUALIFIER_RULES_ENABLED, getMappingConditionError, selectMatchingMappings } from '../../../../../helpers/transactionRuleConditions';

const MOBILE_SIZE = 992;
const TABLET_SIZE = 1200;
// A new rule for a payment without IBAN waits for its text as a card with a "draft-…" id.
const isDraftId = (id) => typeof id === 'string' && id.startsWith('draft-');
var Setting = Autoload.Setting;
var lang = Setting[Setting.language_default];

const tableCellStyle = {
    whiteSpace: 'nowrap', 
    overflow: 'hidden', 
    textOverflow: 'ellipsis', 
    fontSize: '14px', 
    fontFamily: 'Inter, sans-serif', 
    height: 'auto !important',
    fontWeight: '400',
    borderTop: '8px solid white'
}

function Value({
  value,
  label,
  onRemove,
  classNames,
  ...others
}) {
  console.log('Value: ', others);
  return (
    <div {...others}>
      {/* <Tooltip label={others.type === 'tenant' ? `Mietzahlung: ${label}` : `Beleg: ${label}`}> */}
        <Group
          style={{
            cursor: 'pointer',
            backgroundColor: others.type === 'tenant' ? 'rgb(247, 227, 205)' : '#E3E3FC',
            border: 'none',
            borderRadius: '10px',
            padding: '5px 12px',
          }}
          justify={'center'}
          align={'center'}
          wrap="nowrap"
          gap={8}
        >
          <Group align={'center'} justify={'space-between'} wrap="nowrap" gap={8}>
            <img src={others.type === 'tenant' ? RentIcon : ReceiptsIcon} style={{width: '14px', height: '14px'}} />
            {/* <span style={{ lineHeight: 1, fontSize: '12px', whiteSpace: 'nowrap', fontWeight: '300', color: '#111147' }}>{label}</span> */}
            <TruncatedTextHandler className={'transaction-assignment-capsule'} text={others.type === 'tenant' ? `Mietzahlung: ${label}` : `Beleg: ${label}`} maxWidth={others.type === 'tenant' ? 350 : 200}/>
          </Group>
          {<Group align={'center'} justify='right'>
            <CloseButton
              onMouseDown={onRemove}
              variant="transparent"
              size={14}
              iconSize={14}
              tabIndex={-1}
              style={{marginLeft: 8, marginRight: -4}}
            />
          </Group>}
        </Group>
      {/* </Tooltip> */}
    </div>
  );
}

const SelectItem = forwardRef(
  ({ label, ...others }, ref) => (
    <div ref={ref} {...others}>
      {console.log('SelectItem: ', label, others.value)}
      <Group wrap="nowrap">
        <div style={{fontStyle: others.value === 'showOldTenants' && 'italic', fontWeight: others.value === 'showOldTenants' && '400'}}>
          <spacing>{label}</spacing>
        </div>
      </Group>
    </div>
  )
);

// Cycled while the suggestion request is in flight. The call takes a few seconds (a model
// round trip on top of four hellohousing fetches), which is long enough that a bare spinner
// reads as a hang. These name the actual stages of the request rather than claiming progress
// — the endpoint answers in one response, so there is none to report.
const AI_LOADING_STEPS = [
  'Transaktion wird gelesen …',
  'Mieter und offene Mieten werden abgeglichen …',
  'Vorhandene Belege werden geprüft …',
  'Vorschlag wird formuliert …',
];

const AI_LOADING_STEP_INTERVAL_MS = 2200;

// Off for production deployment, same switch as PaymentsList.jsx's SHOW_AI_BULK_ASSIGNMENT.
const SHOW_AI_TRANSACTION_SUGGESTION = false;

const AI_CONFIDENCE = {
  high: { label: 'hohe Sicherheit', color: '#059266', background: 'rgba(5, 146, 102, 0.12)' },
  medium: { label: 'mittlere Sicherheit', color: '#B67A12', background: 'rgba(197, 140, 30, 0.14)' },
  low: { label: 'geringe Sicherheit', color: '#727293', background: 'rgba(114, 114, 147, 0.12)' },
};

// Self-contained so the panel can live in this modal without a stylesheet change; every
// selector is prefixed to keep it out of the global namespace. Mirrors the visual language
// of AiMessageAssistantModal (shimmer skeletons, pulsing icon, fading status line) so the
// two AI entry points read as the same feature.
const AI_PANEL_STYLES = `
.ai-assign-panel {
  position: relative; overflow: hidden;
  background: #F7F7FD; border: 1px solid #DADAE5; border-radius: 6px; padding: 12px 14px;
  animation: ai-assign-panel-in 320ms cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes ai-assign-panel-in {
  from { opacity: 0; transform: translateY(-4px); }
  to { opacity: 1; transform: none; }
}

/* A light sweep across the card while the request is in flight, so the whole panel reads as
   working rather than just the spinner in its corner. */
.ai-assign-panel--busy::after {
  content: ''; position: absolute; inset: 0; pointer-events: none;
  background: linear-gradient(100deg, transparent 20%, rgba(85, 85, 255, 0.09) 50%, transparent 80%);
  background-size: 220% 100%;
  animation: ai-assign-sweep 1.9s ease-in-out infinite;
}
@keyframes ai-assign-sweep {
  0% { background-position: 130% 0; }
  100% { background-position: -60% 0; }
}

.ai-assign-title {
  font-family: 'Inter', sans-serif; font-size: 14px; font-weight: 500; color: #111147;
}
.ai-assign-hint, .ai-assign-reason {
  font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 400; color: #727293; line-height: 18px;
}
.ai-assign-headline {
  font-family: 'Inter', sans-serif; font-size: 13px; font-weight: 500; color: #111147; line-height: 19px;
}
.ai-assign-error { font-family: 'Inter', sans-serif; font-size: 13px; color: #E8193C; line-height: 18px; }

.ai-assign-icon { width: 16px; height: 16px; }
.ai-assign-icon--busy { animation: ai-assign-pulse 1.8s ease-in-out infinite; }
@keyframes ai-assign-pulse {
  0%, 100% { transform: scale(1); opacity: 0.75; }
  50% { transform: scale(1.18); opacity: 1; }
}

.ai-assign-status {
  font-family: 'Inter', sans-serif; font-size: 13px; font-weight: 400; color: #13135C;
  animation: ai-assign-fade 400ms ease;
}
@keyframes ai-assign-fade { from { opacity: 0; } to { opacity: 1; } }

/* Two shimmering lines standing in for the suggestion being worked out. */
.ai-assign-skeleton { display: flex; flex-direction: column; gap: 8px; width: 100%; }
.ai-assign-skeleton-line {
  height: 10px; border-radius: 5px;
  background: linear-gradient(90deg, #EFEFF5 0%, #DADAFF 40%, #EFEFF5 80%);
  background-size: 200% 100%;
  animation: ai-assign-shimmer 1.6s ease-in-out infinite;
}
@keyframes ai-assign-shimmer {
  0% { background-position: 150% 0; }
  100% { background-position: -50% 0; }
}

.ai-assign-result { animation: ai-assign-result-in 380ms cubic-bezier(0.16, 1, 0.3, 1); }
@keyframes ai-assign-result-in {
  from { opacity: 0; transform: translateY(6px); }
  to { opacity: 1; transform: none; }
}

.ai-assign-pill {
  font-family: 'Inter', sans-serif; font-size: 11px; font-weight: 500;
  border-radius: 10px; padding: 2px 9px; white-space: nowrap;
}
.ai-assign-source {
  font-family: 'Inter', sans-serif; font-size: 11px; font-weight: 400; color: #727293;
  border: 1px solid #DADAE5; border-radius: 10px; padding: 2px 9px; background: #FFFFFF; white-space: nowrap;
}

.ai-assign-applied {
  font-family: 'Inter', sans-serif; font-size: 12px; font-weight: 400; color: #059266;
  animation: ai-assign-applied-in 420ms cubic-bezier(0.16, 1, 0.3, 1);
}
@keyframes ai-assign-applied-in {
  0% { opacity: 0; transform: scale(0.96); }
  60% { transform: scale(1.02); }
  100% { opacity: 1; transform: scale(1); }
}

@media (prefers-reduced-motion: reduce) {
  .ai-assign-panel,
  .ai-assign-panel--busy::after,
  .ai-assign-icon--busy,
  .ai-assign-status,
  .ai-assign-skeleton-line,
  .ai-assign-result,
  .ai-assign-applied { animation: none; }
}
`;

export class AssignTransactionModal extends Component {
  state = {
    isMobile: window.innerWidth <= MOBILE_SIZE,
    isTablet: window.innerWidth <= TABLET_SIZE,
    hover1: false,
    hover2: false,
    hover3: false,
    hover4: false,
    selectedType: null,
    tableHeader: ['Mieter', 'Mieteinheit', 'Einzug', 'Auszug'],
    receiptsTableHeader: ['Name', 'Betrag (€)', 'Datum'],
    selectedTenant: [],
    selectedReceiptType: null,
    receiptsList: [],
    selectedReceipts: [],
    receiptsLoader: false,
    vatTypes: [
        {label: '19,00 %'},
        {label: '7,00 %'},
        {label: 'anderer'}
    ],
    taxCostTypes: [
    // {label: 'Abschreibungen für GWG'},
    {label: 'Schuldzinsen'},
    {label: 'Geldbeschaffungskosten'},
    {label: 'Erhaltungsaufwendungen'},
    {label: 'Laufende Betriebskosten'},
    {label: 'Verwaltungskosten'},
    {label: 'Sonstige Kosten'},

    {label: 'Erstattete Vorauszahlungen'},
    {label: 'Erhaltene Nachzahlungen'},
    {label: 'Vereinnahmte Kautionen / Mieten aus Vorjahren'},
    {label: 'Vom Finanzamt erstattete Umsatzsteuer'},
    {label: 'Öffentliche Zuschüsse'},
    {label: 'AfA Gebäude'},
    {label: 'AfA bewegliche Wirtschaftsgüter'},
    {label: 'An Finanzamt gezahlte Umsatzsteuer'},
    {label: 'Renten, dauernde Lasten'},
    ],
    selectedVatType: [],
    customVatType: '0%',
    selectedTaxCostType: [],
    vatAmount: null, 
    netAmount: null,
    netInFocus: false,
    vatInFocus: false,
    vatPercentInFocus: false,
    selectReceiptsForTransactionAssigmentModalOpen: false,
    autoReceiptCreation: false,
    autoReceiptCreationOldStatus: false,
    tenants: [],
    tenantsLoading: true,
    dropdownIcon: Down,
    addReceiptOpen: false,
    ReceiptPage: true,
    rightSectionProps: {
      onClick: ()=> this.setState({selectReceiptsForTransactionAssigmentModalOpen: true})
    },
    showModal: false,
    ImageOpen: false,
    currentRecord: null,
    selectedMonth: null,
    dropdownIconForMonths: Down,
    isEarlyPaymentEnabled: false,
    mappings: [],
    costTypes: [],
    stopToggle: false,
    openCostTypeMenu: false,
    openTaxCostTypeMenu: false,
    openTaxRateMenu: false,
    customTaxRate: false,
    mappingLoader: false,
    openTenantMenu: false,
    // The rule's tenant menu, like the selector above: current tenants unless asked, searchable.
    ruleTenantSearch: '',
    ruleShowOldTenants: false,
    openIsEarlyPaymentMenu: false,
    openAutoAssignReceiptTenantTransaction: false,
    currentBillingPeriod: null,
    openDeleteAllTransactionMappingConfirmationModal: false,
    newCreatedMappings: [],
    openApplyMappingToLegacyTransactionsModal: false,
    applyMappingToLegacyTransactions: false,
    hideOldTenants: false,
    heatingCostTypes: [],
    costTypeMenuOptionHover: null,
    aiSuggestionLoading: false,
    aiSuggestion: null,
    aiSuggestionError: null,
    aiSuggestionApplied: false,
    aiSuggestedReceipt: null,
    aiLoadingStep: 0,
    draftMappings: [],
    // Ids of cards whose rule is being created: "new-…" for an immediate one, else the draft's.
    creatingMappings: [],
    saveWhenCreated: false,
    conditionEdits: {},
  };

  constructor(props) {
    super(props);
    this.selectRef = createRef();
  }

  componentDidMount(){
    const {edit, selectedTransaction} = this.props;
    if(edit){
      if(selectedTransaction?.transactionAssigments.receiptIds?.length > 0){
        this.setState({selectedReceipts: selectedTransaction?.transactionAssigments.receiptIds, selectedType: 'CREDIT_DEBIT_BALANCE'}, ()=> this.getReceipts());
      }else if(selectedTransaction?.transactionAssigments.tenantId){
        this.setState({selectedTenant: [selectedTransaction?.transactionAssigments.tenantId], selectedMonth: selectedTransaction?.transactionAssigments.rentalMonth && dayjs(selectedTransaction?.transactionAssigments.rentalMonth).format('MMMM YYYY'), selectedType: 'RENTAL_INCOME'});
      }
    }
    this.fetchTenants();
    this.getTransactionMapping(true);
    this.getUtilityBillingCostTypes();
    this.getCurrentBillingPeriod();
  }

  // Fetches rental units + their tenants directly instead of reading state.tenantDataReducer.rentalUnits:
  // that redux slice is populated by whichever page loaded it last, dispatched as soon as the
  // last-*fired* per-rental-unit tenant request resolves rather than the last to actually finish,
  // so it can be caught mid-load with some units still missing tenants.
  fetchTenants = () => {
    const propertyId = this.props.propertySelected?.id;
    if(propertyId === undefined){
      this.finalizeTenants([]);
      return;
    }
    this.setState({tenantsLoading: true});
    GlobalServices._getRentalUnitsByProperty(this, 'handleGetRentalUnitsForTenants', {id: propertyId});
  }

  handleGetRentalUnitsForTenants = (response) => {
    if(response.status && response.statuscode === 200 && response.result?.length > 0){
      this._rentalUnitsWithTenants = response.result.map((ru)=> ({id: ru.id, name: ru.name, tenantsData: []}));
      this._pendingTenantFetches = this._rentalUnitsWithTenants.length;
      this._rentalUnitsWithTenants.forEach((rentalUnit)=>
        GlobalServices._getTenantsByRentalUnitID(this, 'handleGetTenantsForRentalUnit', {rentalUnit})
      );
    }else{
      this.finalizeTenants([]);
    }
  }

  handleGetTenantsForRentalUnit = (response) => {
    const rentalUnit = response.other?.rentalUnit;
    if(rentalUnit && response.status && response.statuscode === 200 && Array.isArray(response.result)){
      rentalUnit.tenantsData = response.result.map((tenant)=> TenantDataHandler.setTenantFormData(tenant, false));
    }
    this._pendingTenantFetches -= 1;
    if(this._pendingTenantFetches <= 0){
      this.finalizeTenants(this._rentalUnitsWithTenants || []);
    }
  }

  finalizeTenants = (rentalUnits) => {
    let tenants = [];
    rentalUnits.forEach((rentalUnit)=> rentalUnit.tenantsData.forEach((tenant)=> {
        if(tenant.vacant === false){
            let noOfMonthBetweenMoveInMoveOut= this.getMonthsBetween(tenant.in, tenant.out.length > 0 ? tenant.out : null);
            tenants.push({...tenant, rentalUnitName: rentalUnit.name, value: tenant.id, label: `${rentalUnit.name}: ${tenant.name} (${tenant.in} - ${tenant.out ? tenant.out : 'aktuell'})`, noOfMonthBetweenMoveInMoveOut});
        }
    }));
    tenants = tenants.sort((a,b)=> a.name.toLowerCase().localeCompare(b.name.toLowerCase(), 'de', { numeric: true }));
    this.setState({tenants, tenantsLoading: false});
  }

  componentDidUpdate(prevProps, prevState){
    const {edit, selectedTransaction} = this.props;
    const {selectedMonth, selectedTenant, tenants} = this.state;
    if(selectedTenant.length === 0 && selectedMonth){
      this.setState({selectedMonth: null});
    }

    if((prevState.selectedTenant.length === 0 && selectedTenant.length > 0)
      || (prevState.selectedTenant.length > 0 && selectedTenant.length > 0 && prevState.selectedTenant[0] !== selectedTenant[0])
      || (prevState.tenants.length !== tenants.length && selectedTenant.length > 0)){
      let sTenant = tenants.find((tenant)=> tenant.id === selectedTenant[0]);
      if(sTenant !== undefined){
        if(sTenant?.noOfMonthBetweenMoveInMoveOut?.length > 0){
          let sMonth= dayjs(sTenant?.noOfMonthBetweenMoveInMoveOut[0]?.value, 'MMMM YYYY').isAfter(dayjs(selectedTransaction?.bankBookingDate)) ? dayjs(sTenant?.noOfMonthBetweenMoveInMoveOut[sTenant?.noOfMonthBetweenMoveInMoveOut.length - 1]?.value, 'MMMM YYYY').isBefore(dayjs(selectedTransaction?.bankBookingDate)) ? dayjs(selectedTransaction?.bankBookingDate).format('MMMM YYYY') : sTenant?.noOfMonthBetweenMoveInMoveOut[sTenant?.noOfMonthBetweenMoveInMoveOut.length - 1]?.value : sTenant?.noOfMonthBetweenMoveInMoveOut[0]?.value;
          if(edit && selectedMonth === null){
            this.setState({selectedMonth: selectedTransaction?.transactionAssigments?.rentalMonth && dayjs(selectedTransaction?.transactionAssigments.rentalMonth).format('MMMM YYYY')})
          }else if(!edit){
            this.setState({selectedMonth: sMonth});
          }
        }
      }
    }
  }

  openDropdown = () => {
    if (this.selectRef.current) {
      this.selectRef.current.openDropdown(); // Programmatically open the dropdown
    }
  };

  getMonthsBetween=(dateA, dateB)=> {
    const startDate = dayjs(dateA, 'DD.MM.YYYY');
    const endDate = dateB ? dayjs(dateB, 'DD.MM.YYYY').isAfter(dayjs().add(1, 'M')) ? dayjs().add(1, 'M') : dayjs(dateB, 'DD.MM.YYYY') : dayjs().add(1, 'M');
    console.log('endDate: ', endDate, dateB);
    const months = [];
  
    // let current = startDate;
  
    // while (current.isBefore(endDate) || current.isSame(endDate, 'month')) {
    //   months.push({month: current, label: current.format('MMMM YYYY'), value: current.format('MMMM YYYY')}); // Customize the format as needed
    //   current = current.add(1, 'month');
    // }
  
    // return months;

    let current = endDate;

    while (current.isAfter(startDate) || current.isSame(startDate, 'month')) {
      months.push({month: current, label: current.format('MMMM YYYY'), value: current.format('MMMM YYYY')}); // Customize the format as needed
      current = current.subtract(1, 'month');
    }

    return months;
  }

  handleMouseEnter=(type)=>{
    this.setState({[type]: true});
  }

  handleMouseLeave=(type)=>{
      this.setState({[type]: false});
  }

  getReceipts=()=>{
    this.setState({receiptsLoader: true});
    GlobalServices._getReceiptsByPropertyWithFilters(this, 'handleGetReceipts', {propertyId: this.props?.propertySelected?.id, includeDetails: true });
    // Autoload.HttpRequestAxios.HttpRequest(
    //     // Autoload.Setting.rm_api_base_url + 'property/' + this.props.propertySelected.id,
    //     Autoload.Setting.rm_api_base_url + 'search?' + `propertyId=${this.props.propertySelected.id}` + `&includeDetails=false`,
    //     'GET',
    //     null,
    //     null,
    //     false,
    //     true,
    //     false,
    //     this,
    //     'handleGetReceipts',
    //     null,
    //     false,
    //     '',
    //     {
    //       'Content-Type': 'application/json',
    //       Authorization: Autoload.Utils.getAuthToken(),
    //     },
    //     true
    // );
  }

  handleGetReceipts(response){
    if(response.status && response.statuscode === 200){
        this.setState({receiptsList: response.result.map((receipt)=> ({...receipt, value: receipt.id, label: receipt.name}))});
    }
    // setTimeout(() => {
    //   this.setState({receiptsLoader: false});  
    // }, 5000);
    this.setState({receiptsLoader: false});  
  }

  getUtilityBillingCostTypes=()=>{
    GlobalServices._getCostTypeByProperty(this, 'handleGetUtilityBillingCostTypes', this.props.propertySelected);
  }

  handleGetUtilityBillingCostTypes(response){
    if(response.status && response.statuscode === 200){
      this.setState({
        costTypes: response.result.filter((costType)=> costType.useInReceiptMgmt).map((costType)=> ({...costType, label: costType.costTypeName, value: costType.id}))
      }, ()=> this.getHeatingCostTypes());
    }
  }

  getHeatingCostTypes = () => {
    GlobalServices._getHeatingCostTypesByProperty(this, 'handleGetHeatingCostTypes', this.props.propertySelected);  
  }

  handleGetHeatingCostTypes = (response) => {
   if(response.status && response.statuscode === 200){
    this.setState({heatingCostTypes: response.result.map((heatingCostTypeObject)=> ({...heatingCostTypeObject, id: heatingCostTypeObject?.id || heatingCostTypeObject?.heatingCostTypeName, label: heatingCostTypeObject.heatingCostTypeName, value: heatingCostTypeObject.heatingCostTypeName}))});
   } 
  }

  // --- AI assignment suggestion ------------------------------------------
  //
  // Asks the agent server what this transaction should be assigned to, then *prefills* the
  // controls the user was going to set by hand. Deliberately a prefill and not a write: the
  // suggestion lands in exactly the state a manual selection would produce, so the user still
  // confirms with the modal's normal save button and can change anything first. A wrong
  // assignment silently corrupts the rental-payment overview and the utility billing that
  // reads from it, which is too expensive to let a model commit on its own.

  componentWillUnmount(){
    this.abortAiSuggestion();
    this.stopAiLoadingAnimation();
  }

  abortAiSuggestion = () => {
    if(this.aiController){
      this.aiController.abort();
      this.aiController = null;
    }
  }

  getAiSuggestion = async () => {
    const {selectedTransaction, propertySelected, accountData, selectedBankAccount, profileData} = this.props;

    // bankAccountId identifies the account the suggestion service reads the transaction from.
    // The transaction carries it, but the modal is also opened from screens that pass the
    // account separately, so both are accepted.
    const bankAccountId = selectedTransaction?.bankAccountId || selectedBankAccount?.id;
    if(!selectedTransaction?.id || !bankAccountId){
      this.stopAiLoadingAnimation();
      this.setState({aiSuggestionError: 'Für diese Transaktion ist keine KI-Analyse möglich.'});
      return;
    }

    this.abortAiSuggestion();
    this.aiController = new AbortController();
    this.setState({aiSuggestionLoading: true, aiSuggestionError: null, aiSuggestion: null, aiSuggestionApplied: false});
    this.startAiLoadingAnimation();

    try{
      const response = await fetch(`${AI_AGENT_BASE_URL}/suggestTransactionAssignments`, {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        signal: this.aiController.signal,
        body: JSON.stringify({
          encryptedToken: profileData?.auth?.encryptedToken,
          accountId: accountData?.accountId,
          userId: profileData?.id,
          propertyId: propertySelected?.id,
          bankAccountId,
          transactionIds: [selectedTransaction.id],
        }),
      });

      const data = await response.json().catch(()=> null);

      if(!response.ok){
        // 402 carries the credit-gate copy from the server; the other failures already come
        // back as user-facing German, so the generic fallback is only for a dead connection.
        this.stopAiLoadingAnimation();
        this.setState({
          aiSuggestionLoading: false,
          aiSuggestionError: data?.error || 'Der Vorschlag konnte nicht erstellt werden. Bitte versuchen Sie es erneut.'
        });
        return;
      }

      const suggestion = data?.result?.suggestions?.[0] || null;
      this.stopAiLoadingAnimation();
      this.setState({aiSuggestionLoading: false, aiSuggestion: suggestion});
    }catch(error){
      this.stopAiLoadingAnimation();
      if(error.name === 'AbortError') return;
      this.setState({
        aiSuggestionLoading: false,
        aiSuggestionError: 'Der Vorschlag konnte nicht erstellt werden. Bitte versuchen Sie es erneut.'
      });
    }
  }

  // Puts the suggestion into the modal's own selection state — the same fields the user's
  // clicks would have set — so the existing save path handles the write unchanged.
  applyAiSuggestion = () => {
    const {aiSuggestion} = this.state;
    if(!aiSuggestion) return;

    if(aiSuggestion.suggestionType === 'RENTAL_INCOME'){
      this.setState({
        selectedType: 'RENTAL_INCOME',
        selectedTenant: [aiSuggestion.tenantId],
        // A rule fixes the tenant but not the month (which month a payment covers depends on
        // what is still open), so rentalMonth can legitimately be absent — leave the modal's
        // own month selection alone in that case rather than clearing it.
        selectedMonth: aiSuggestion.rentalMonth ? dayjs(aiSuggestion.rentalMonth).format('MMMM YYYY') : this.state.selectedMonth,
        hideOldTenants: true,
        aiSuggestionApplied: true,
      });
      return;
    }

    if(aiSuggestion.suggestionType === 'CREDIT_DEBIT_BALANCE'){
      this.setState({
        selectedType: 'CREDIT_DEBIT_BALANCE',
        selectedReceipts: aiSuggestion.receiptIds || [],
        aiSuggestionApplied: true,
      }, ()=> this.getReceipts());
      return;
    }

    if(aiSuggestion.suggestionType === 'NEW_RECEIPT'){
      // Opens the normal "Beleg anlegen" form, which already prefills name/amount/date/notes
      // from the transaction; aiSuggestedReceipt additionally carries the proposed name and
      // cost type. The user completes and saves the receipt there, and the modal's existing
      // toggle handler selects the new receipt for assignment.
      this.setState({
        selectedType: 'CREDIT_DEBIT_BALANCE',
        aiSuggestedReceipt: aiSuggestion.newReceipt,
        addReceiptOpen: true,
        aiSuggestionApplied: true,
      });
    }
  }

  hasAiConsent = () => isAiConsentAccepted(this.props.accountData);

  startAiLoadingAnimation = () => {
    this.stopAiLoadingAnimation();
    this.setState({aiLoadingStep: 0});
    this.aiLoadingInterval = setInterval(() => {
      // Holds on the last step rather than looping: cycling back to "Transaktion wird
      // gelesen …" after ten seconds would suggest the request had restarted.
      this.setState((prevState) => ({
        aiLoadingStep: Math.min(prevState.aiLoadingStep + 1, AI_LOADING_STEPS.length - 1)
      }));
    }, AI_LOADING_STEP_INTERVAL_MS);
  }

  stopAiLoadingAnimation = () => {
    if(this.aiLoadingInterval){
      clearInterval(this.aiLoadingInterval);
      this.aiLoadingInterval = null;
    }
  }

  aiSuggestionHeadline = (suggestion) => {
    switch(suggestion?.suggestionType){
      case 'RENTAL_INCOME':
        return `Mietzahlung von ${suggestion.tenantName || 'dem vorgeschlagenen Mieter'}${suggestion.rentalMonth ? ` für ${dayjs(suggestion.rentalMonth).format('MMMM YYYY')}` : ''}`;
      case 'CREDIT_DEBIT_BALANCE':
        return `Beleg: ${(suggestion.receipts || []).map((receipt)=> receipt.name).filter(Boolean).join(', ')}`;
      case 'NEW_RECEIPT':
        return `Neuen Beleg anlegen: ${suggestion.newReceipt?.name || ''}${suggestion.newReceipt?.costTypeName ? ` (${suggestion.newReceipt.costTypeName})` : ''}`;
      default:
        return 'Kein passender Vorschlag gefunden';
    }
  }

  renderAiSuggestion = () => {
    const {aiSuggestionLoading, aiSuggestion, aiSuggestionError, aiSuggestionApplied, aiLoadingStep} = this.state;

    // The same consent the messaging assistant enforces — this calls the same agent server
    // with the same account's data, so it cannot be the one AI entry point that skips it.
    if(!this.hasAiConsent()){
      return (
        <div className='ai-assign-panel'>
          <style>{AI_PANEL_STYLES}</style>
          <Stack gap={6}>
            <Group gap={8} wrap='nowrap' align='center'>
              <img src={AiAgentIcon} className='ai-assign-icon' alt='' />
              <span className='ai-assign-title'>KI-Vorschlag</span>
            </Group>
            <span className='ai-assign-hint'>
              Um die KI-Funktionen von hellohousing zu nutzen, müssen Sie den KI-Nutzungsbedingungen
              einmalig zustimmen. Öffnen Sie dazu den hellohousing KI-Assistenten und bestätigen Sie
              die Bedingungen dort.
            </span>
          </Stack>
        </div>
      );
    }

    const confidence = AI_CONFIDENCE[aiSuggestion?.confidence];
    const isNone = aiSuggestion?.suggestionType === 'NONE';

    return (
      <div className={`ai-assign-panel${aiSuggestionLoading ? ' ai-assign-panel--busy' : ''}`}>
        <style>{AI_PANEL_STYLES}</style>
        <Stack gap={10}>
          <Group justify='space-between' wrap='nowrap' align='center'>
            <Group gap={8} wrap='nowrap' align='center'>
              <img
                src={AiAgentIcon}
                className={`ai-assign-icon${aiSuggestionLoading ? ' ai-assign-icon--busy' : ''}`}
                alt=''
              />
              <span className='ai-assign-title'>KI-Vorschlag</span>
              {aiSuggestion && !isNone && confidence &&
              <span className='ai-assign-pill' style={{color: confidence.color, background: confidence.background}}>
                {confidence.label}
              </span>}
              {/* A rule-derived suggestion did not involve the model at all; saying so is the
                  difference between "the AI guessed" and "you already decided this once". */}
              {aiSuggestion?.source === 'rule' &&
              <span className='ai-assign-source'>aus bestehender Regel</span>}
            </Group>
            {!aiSuggestion && !aiSuggestionLoading && !aiSuggestionError &&
            <div>
              <ColorButton
                text={'Vorschlag erstellen'}
                className='purple-btn'
                onClick={()=> this.getAiSuggestion()}
              />
            </div>}
          </Group>

          {!aiSuggestion && !aiSuggestionLoading && !aiSuggestionError &&
          <span className='ai-assign-hint'>
            Die KI prüft Betrag, Gegenpartei und Verwendungszweck dieser Transaktion und schlägt
            eine passende Zuordnung vor. Sie prüfen den Vorschlag, bevor etwas gespeichert wird.
          </span>}

          {aiSuggestionLoading &&
          <Stack gap={10}>
            <span className='ai-assign-status' key={aiLoadingStep}>
              {AI_LOADING_STEPS[aiLoadingStep] || AI_LOADING_STEPS[0]}
            </span>
            <div className='ai-assign-skeleton'>
              <div className='ai-assign-skeleton-line' style={{width: '72%'}} />
              <div className='ai-assign-skeleton-line' style={{width: '46%'}} />
            </div>
          </Stack>}

          {aiSuggestionError &&
          <Group justify='space-between' wrap='nowrap' align='center' gap={12}>
            <span className='ai-assign-error'>{aiSuggestionError}</span>
            <div>
              <ColorButton text={'Erneut versuchen'} className='gray-btn' onClick={()=> this.getAiSuggestion()}/>
            </div>
          </Group>}

          {aiSuggestion && !aiSuggestionLoading &&
          <Stack gap={6} className='ai-assign-result'>
            <span className='ai-assign-headline'>{this.aiSuggestionHeadline(aiSuggestion)}</span>
            {aiSuggestion.reason && <span className='ai-assign-reason'>{aiSuggestion.reason}</span>}

            <Group justify='space-between' wrap='nowrap' align='center' style={{marginTop: '2px'}}>
              {/* Retry stays available on a "no suggestion" answer, since that is the case
                  where the user is most likely to want another go. */}
              {isNone
                ? <div><ColorButton text={'Erneut versuchen'} className='gray-btn' onClick={()=> this.getAiSuggestion()}/></div>
                : <span />}
              {!isNone && (aiSuggestionApplied
                ? <span className='ai-assign-applied'>✓ Übernommen — bitte prüfen und speichern.</span>
                : <div><ColorButton text={'Übernehmen'} className='purple-btn' onClick={()=> this.applyAiSuggestion()}/></div>)}
            </Group>
          </Stack>}
        </Stack>
      </div>
    );
  }

  postTransactionReceiptAssignment=(newReceiptsToAdd=[])=>{
    const {selectedTransaction, propertySelected} = this.props;
    const {selectedReceipts, selectedTenant, selectedType, autoReceiptCreation, autoReceiptCreationOldStatus, selectedMonth} = this.state;

    if(selectedType === 'CREDIT_DEBIT_BALANCE' && (selectedReceipts.length > 0 || newReceiptsToAdd.length > 0)){
      console.log('postTransactionReceiptAssignment: newReceiptsToAdd, selectedReceipts:', newReceiptsToAdd, selectedReceipts);
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.finance_api_base_url + 'ReceiptTenantTransactions',
        'POST',
        {
          transactionId: selectedTransaction?.id,
          receiptIds: newReceiptsToAdd.length > 0 ? newReceiptsToAdd : selectedReceipts,
          tenantId: null,
          propertyId: propertySelected.id,
          rentalMonth: null
        },
        null,
        false,
        true,
        false,
        this,
        'handlePostTransactionReceiptAssignment',
        {type: 'receipt', eol: true},
        false,
        '',
        {
          'Content-Type': 'application/json',
          Authorization: Autoload.Utils.getAuthToken(),
        },
        true
      );
      
    }else if(selectedType === 'RENTAL_INCOME' && selectedTenant.length > 0){
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.finance_api_base_url + 'ReceiptTenantTransactions',
        'POST',
        {
          transactionId: selectedTransaction?.id,
          receiptIds: null,
          tenantId: selectedTenant[0],
          propertyId: propertySelected.id,
          rentalMonth: dayjs(selectedMonth, 'MMMM YYYY').add(1, 'day').utc().format()
        },
        null,
        false,
        true,
        false,
        this,
        'handlePostTransactionReceiptAssignment',
        {type:'tenant', eol: true},
        false,
        '',
        {
          'Content-Type': 'application/json',
          Authorization: Autoload.Utils.getAuthToken(),
        },
        true
      );
    }else{
      // Nothing to assign, e.g. Speichern with only new rules.
      this.finishSave();
    }
  }

  handlePostTransactionReceiptAssignment(response){
    const {edit, selectedTransaction, toggle} = this.props;
    const {autoReceiptCreation, selectedReceipts, autoReceiptCreationOldStatus, applyMappingToLegacyTransactions} = this.state;
    
    if(response.status && response.statuscode === 200){
      showNotification({
        message: edit ? 'Änderungen übernommen.' : 'Beleg erfolgreich zugeordnet.',
        icon: <img src={GreenTick} alt='green-tick'/>,
        id: 'assignReceiptTransaction'
      });
      this.finishSave();
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
        id: 'assignReceiptTransactionError'
      });
    }
  }

  // The last step of Speichern, once the assignment (if any) is saved: rules the user chose to
  // apply to existing transactions are applied, then the modal closes.
  finishSave=()=>{
    if(this.state.applyMappingToLegacyTransactions){
      this.applyToAllPreviousTransactions();
    }else{
      this.props.toggle(true);
    }
  }

  checkForDeletion=()=>{
    const {selectedTransaction, toggle, edit} = this.props;
    const {selectedReceipts, selectedType, selectedTenant, autoReceiptCreation, autoReceiptCreationOldStatus, selectedMonth} = this.state;

    if(edit){
      //this.firstDeleteThanPostTransactionMapping();
      
      if(selectedType === 'RENTAL_INCOME'){
        if(selectedTransaction?.transactionAssigments?.receiptIds?.length > 0){
          this.deleteTransactionReceiptAssignment(selectedTransaction?.transactionAssigments.receiptIds);
        }else{
          this.deleteTransactionTenantAssignment(selectedTransaction?.transactionAssigments?.tenantId);
        }
        // else if(selectedTransaction?.transactionAssigments?.tenantId && (selectedTenant.length === 0 || selectedTenant[0] !== selectedTransaction?.transactionAssigments?.tenantId || selectedMonth !== selectedTransaction?.transactionAssigments?.rentalMonth)){
        //   this.deleteTransactionTenantAssignment(selectedTransaction?.transactionAssigments?.tenantId);
        // }
        // else if(selectedTransaction?.transactionAssigments?.tenantId && (selectedTenant.length > 0 || selectedTenant[0] !== selectedTransaction?.transactionAssigments?.tenantId || selectedMonth !== selectedTransaction?.transactionAssigments?.rentalMonth)){
        //   this.handleAddTenantReceiptAssigment();
        // }
      }else if(selectedType === 'CREDIT_DEBIT_BALANCE'){
        if(selectedTransaction?.transactionAssigments?.tenantId){
          this.deleteTransactionTenantAssignment(selectedTransaction?.transactionAssigments?.tenantId);
        }else{
          let oldReceiptsToDelete= selectedTransaction?.transactionAssigments?.receiptIds?.length > 0 ? selectedTransaction?.transactionAssigments.receiptIds.filter((receiptId)=> selectedReceipts.find((id)=> receiptId === id) === undefined) : [];
          if(oldReceiptsToDelete.length > 0){
            this.deleteTransactionReceiptAssignment(oldReceiptsToDelete);
          }else{
            this.handleAddTenantReceiptAssigment();
          }
        } 
      }else{
        this.finishSave();
      }
    }else{
      //this.firstDeleteThanPostTransactionMapping();
      this.handleAddTenantReceiptAssigment();
    }
  }

  firstDeleteThanPostTransactionMapping=()=> this.deleteAllTransactionMapping();

  transactionMappingSetup=(getTransactionMapping=false)=>{
    const {selectedTransaction, selectedBankAccount, accountData, propertySelected} = this.props;
    const {selectedReceipts, selectedTenant, receiptsList, selectedType, isEarlyPaymentEnabled, autoReceiptCreation} = this.state;
    let payloads=[];
    if(selectedType === 'CREDIT_DEBIT_BALANCE' && selectedReceipts.length > 0){
      let receipts= receiptsList.filter((receipt)=> selectedReceipts.find((receiptId)=> receiptId === receipt.id) !== undefined)
      console.log('transactionMappingSetup: ', receipts);
      
      receipts.map((receipt)=> 
      payloads.push({
        accountId: accountData.accountId,
        propertyId: propertySelected.id,
        bankAccountId: selectedBankAccount.id,
        transactionType: 200,
        counterpartIban: selectedTransaction?.counterpartIban,
        counterpartName:	selectedTransaction?.counterpartName,
        utilityBillingCostTypeId: receipt?.selectedCostTypes?.length > 0 ? receipt?.selectedCostTypes[0]?.id : null,
        heatingCostType: receipt?.heatingCostType || null,
        taxCostType: receipt?.taxCostType,
        taxRate: receipt?.vatPercent,
        tenantId: null,
        isEarlyPaymentEnabled: false
      }));

      this.postTransactionMapping(payloads, getTransactionMapping);
    }else if(selectedType === 'RENTAL_INCOME' && selectedTenant){
      payloads.push({
        accountId: accountData.accountId,
        propertyId: propertySelected.id,
        bankAccountId: selectedBankAccount.id,
        transactionType: 100,
        counterpartIban: selectedTransaction?.counterpartIban,
        counterpartName:	selectedTransaction?.counterpartName,
        utilityBillingCostTypeId: null,
        taxCostType: null,
        taxRate: null,
        tenantId: selectedTenant[0],
        isEarlyPaymentEnabled: autoReceiptCreation ? isEarlyPaymentEnabled : false
      });

      this.postTransactionMapping(payloads, getTransactionMapping);
    }
  }

  // --- Mapping cards (2506) ----------------------------------------------------------------
  //
  // Every mapping is a rule of its own: a condition (this payment's IBAN and/or a text its
  // purpose contains) and one action. The cards list every mapping that fits this payment, of
  // either type. A new rule is created at once, typed after the payment type chosen at the top
  // and matching this payment's IBAN, and is edited in place from there: the action saves on
  // change as before, the condition once an edit is complete.

  // What a card's condition fields show: the user's unsaved edit, else what the mapping holds.
  getConditionEdit=(mapping)=> this.state.conditionEdits[mapping.id] || {
    ibanChecked: !!mapping.counterpartIban,
    textChecked: !!mapping.textQualifier,
    text: mapping.textQualifier || '',
    touched: false,
  };

  // A ticked IBAN box keeps the IBAN the rule already has, else takes this payment's.
  conditionFromEdit=(edit, mapping)=> ({
    counterpartIban: edit.ibanChecked ? (mapping?.counterpartIban || this.props.selectedTransaction?.counterpartIban || null) : null,
    textQualifier: (edit.textChecked && edit.text.trim()) || null,
  });

  // `complete` marks the end of an edit (a checkbox, leaving the text field): the condition is
  // then saved, or a new rule waiting for its text is created, and from then on any problem
  // with it is shown.
  editMappingCondition=(mapping, patch, complete=false)=>{
    const edit = {...this.getConditionEdit(mapping), ...patch, ...(complete && {touched: true})};
    this.setState(({conditionEdits})=> ({conditionEdits: {...conditionEdits, [mapping.id]: edit}}), ()=> {
      if(!complete){
        return;
      }
      if(isDraftId(mapping.id)){
        this.createDraftMapping(mapping.id);
      }else{
        this.saveMappingCondition(mapping, edit);
      }
    });
  }

  // An invalid condition is not saved; the card keeps showing why.
  saveMappingCondition=(mapping, edit)=>{
    const current = this.state.mappings.find((m)=> m.id === mapping.id) || mapping;
    const condition = this.conditionFromEdit(edit, current);
    if(getMappingConditionError(condition, this.props.selectedTransaction) !== null){
      return;
    }
    if(condition.counterpartIban === (current.counterpartIban || null) && condition.textQualifier === (current.textQualifier || null)){
      // Nothing to save; the boxes stay as the user set them, e.g. a ticked, still empty text box.
      return;
    }
    const {[mapping.id]: saved, ...conditionEdits} = this.state.conditionEdits;
    this.setState({conditionEdits}, ()=> this.updateMapping(mapping.id, condition));
  }

  // The rule a click on "Regel … hinzufügen" creates. The first rule of a type remembers what
  // was just assigned, as the old "Regel merken" switch did; further ones start empty.
  getNewMapping=()=>{
    const {selectedTransaction} = this.props;
    const {selectedType, mappings, receiptsList, selectedReceipts, selectedTenant} = this.state;
    const transactionType = selectedType === 'RENTAL_INCOME' ? 'Rent' : 'Expenditure';
    const firstOfType = !mappings.some((mapping)=> mapping.transactionType === transactionType);
    const receipt = (firstOfType && transactionType === 'Expenditure') ? receiptsList.find((receipt)=> selectedReceipts.includes(receipt.id)) : undefined;
    return {
      transactionType,
      counterpartIban: selectedTransaction?.counterpartIban || null,
      textQualifier: null,
      utilityBillingCostTypeId: receipt?.selectedCostTypes?.length > 0 ? receipt.selectedCostTypes[0]?.id : null,
      heatingCostType: receipt?.heatingCostType || null,
      taxCostType: receipt?.taxCostType || null,
      taxRate: receipt?.vatPercent ?? null,
      tenantId: (firstOfType && transactionType === 'Rent' && selectedTenant.length > 0) ? selectedTenant[0] : null,
      isEarlyPaymentEnabled: false,
    };
  }

  nextCardNumber=()=>{
    this.cardNumber = (this.cardNumber || 0) + 1;
    return this.cardNumber;
  }

  // Created at once with this payment's IBAN. A payment without IBAN has nothing to create a
  // rule from yet: its card waits for a text and the rule is created when the field is left.
  addRuleMapping=()=>{
    const mapping = this.getNewMapping();
    if(mapping.counterpartIban){
      this.postNewMapping(mapping, `new-${this.nextCardNumber()}`);
      return;
    }
    const id = `draft-${this.nextCardNumber()}`;
    this.setState(({draftMappings, conditionEdits})=> ({
      draftMappings: [...draftMappings, {...mapping, id}],
      conditionEdits: {...conditionEdits, [id]: {ibanChecked: false, textChecked: true, text: '', touched: false}},
    }));
  }

  discardDraftMapping=(draftId)=>{
    const {[draftId]: draft, ...conditionEdits} = this.state.conditionEdits;
    this.setState(({draftMappings})=> ({draftMappings: draftMappings.filter((mapping)=> mapping.id !== draftId), conditionEdits}));
  }

  getDraftError=(draft)=> getMappingConditionError(this.conditionFromEdit(this.getConditionEdit(draft), draft), this.props.selectedTransaction);

  createDraftMapping=(draftId)=>{
    const {draftMappings, creatingMappings} = this.state;
    const draft = draftMappings.find((mapping)=> mapping.id === draftId);
    if(!draft || creatingMappings.includes(draftId) || this.getDraftError(draft) !== null){
      return;
    }
    const {id, ...mapping} = draft;
    this.postNewMapping({...mapping, ...this.conditionFromEdit(this.getConditionEdit(draft), draft)}, draftId);
  }

  postNewMapping=(mapping, cardId)=>{
    const {selectedTransaction, accountData, propertySelected, selectedBankAccount} = this.props;
    this.setState(({creatingMappings})=> ({creatingMappings: [...creatingMappings, cardId]}));
    this.postTransactionMapping([{
      ...mapping,
      accountId: accountData.accountId,
      propertyId: propertySelected.id,
      bankAccountId: selectedBankAccount.id,
      transactionType: mapping.transactionType === 'Rent' ? 100 : 200,
      counterpartName: selectedTransaction?.counterpartName,
    }], true, cardId);
  }

  // Speichern. Rules still waiting for their text are created first, and saving goes on once
  // they exist; a rule without a valid condition stops it and shows why.
  handleSave=()=>{
    const {draftMappings, creatingMappings} = this.state;
    const invalidDrafts = draftMappings.filter((draft)=> this.getDraftError(draft) !== null);
    if(invalidDrafts.length > 0){
      this.setState(({conditionEdits})=> ({conditionEdits: {...conditionEdits, ...Object.fromEntries(invalidDrafts.map((draft)=> [draft.id, {...this.getConditionEdit(draft), touched: true}]))}}));
      showNotification({
        message: 'Bitte geben Sie für jede neue Regel einen Verwendungszweck ein oder entfernen Sie sie.',
        icon: <img src={RedCross} alt='red-cross'/>,
        id: 'transactionMappingDraftOpen'
      });
      return;
    }
    if(draftMappings.length > 0 || creatingMappings.length > 0){
      this.setState({saveWhenCreated: true}, ()=> draftMappings.forEach((draft)=> this.createDraftMapping(draft.id)));
      return;
    }
    this.continueSave();
  }

  // Speichern once every new rule exists: offer to apply new rules to existing transactions,
  // then save the assignment.
  continueSave=()=>{
    const {autoReceiptCreation, selectedReceipts, newCreatedMappings} = this.state;
    if(autoReceiptCreation && selectedReceipts.length > 1){
      showNotification({
        message: 'Um eine automatische Regel zu erstellen, wählen Sie bitte nur einen Beleg aus.',
        icon: <img src={RedCross} alt='red-cross'/>,
        id: 'transactionMappingError'
      });
    }else if(newCreatedMappings.length > 0){
      this.setState({openApplyMappingToLegacyTransactionsModal: true});
    }else{
      this.checkForDeletion();
    }
  }

  getNewCreatedMappings=()=> this.state.mappings.filter((mapping)=> this.state.newCreatedMappings.includes(mapping.id));

  // Mappings of both types can fit one payment; applying them only ever uses the type chosen
  // at the top, since a payment is either an expense or rent.
  getMappingsOfSelectedType=()=>{
    const transactionType = this.state.selectedType === 'RENTAL_INCOME' ? 'Rent' : 'Expenditure';
    return this.state.mappings.filter((mapping)=> mapping.transactionType === transactionType);
  }

  // cardId: the card whose rule this creates (see postNewMapping); none for the old flow.
  postTransactionMapping=(payloads, getTransactionMapping=false, cardId=null)=>{
    hideNotification('postTrasactionMappingSuccess');
    payloads.map((payload)=> 
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + 'TransactionMappings',
      'POST',
      payload,
      null,
      false,
      true,
      false,
      this,
      'handlePostTransactionMapping',
      {getTransactionMapping, cardId},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    ));
  }

  handlePostTransactionMapping(response){
    let {newCreatedMappings} = this.state;
    const {cardId} = response.other;
    // No longer being created, whatever the answer; a draft stays for another try on failure.
    this.setState(({creatingMappings})=> ({creatingMappings: creatingMappings.filter((id)=> id !== cardId)}));
    if(response.status && response.statuscode === 200){
      newCreatedMappings.push(response?.result?.id);
      this.setState({newCreatedMappings});
      if(isDraftId(cardId)){
        this.discardDraftMapping(cardId);
      }
      // showNotification({
      //   message: this.props.edit ? 'Änderungen übernommen.' : 'Beleg erfolgreich zugeordnet.',
      //   icon: <img src={GreenTick} alt='green-tick'/>,
      //   id: 'assignReceiptTransaction'
      // });
      if(response.other.getTransactionMapping){
        showNotification({
          message: 'Regel erfolgreich hinzugefügt.',
          icon: <img src={GreenTick} alt='green-tick'/>,
          id: 'postTrasactionMappingSuccess'
        });
        this.getTransactionMapping();
      }else{
        this.props.toggle(true);
      }
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
        id: 'PostTrasactionMappingError'
      });
      // A Speichern waiting for this rule stops; the user tries again.
      this.setState({mappingLoader: false, saveWhenCreated: false});
    }
  }

  putTransactionMapping=(mappingId)=>{
    console.log('putTransactionMapping: ', mappingId);
    const {mappings} = this.state;
    const payload = mappings.find((mapping)=> mapping.id === mappingId);
    if(payload !== undefined){
      this.setState({mappingLoader: mappingId});
      hideNotification('putTrasactionMappingSuccess');
      hideNotification('putTrasactionMappingError');
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.finance_api_base_url + 'TransactionMappings/'+ mappingId,
        'PUT',
        payload,
        null,
        false,
        true,
        false,
        this,
        'handlePutTransactionMapping',
        null,
        false,
        '',
        {
          'Content-Type': 'application/json',
          Authorization: Autoload.Utils.getAuthToken(),
        },
        true
      );
    }
  }

  handlePutTransactionMapping(response){
    if(response.status && response.statuscode === 200){
      showNotification({
        message: 'Regel erfolgreich aktualisiert.',
        icon: <img src={GreenTick} alt='green-tick'/>,
        id: 'putTrasactionMappingSuccess'
      });
      this.getTransactionMapping();
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
        id: 'putTrasactionMappingError'
      });
      this.setState({mappingLoader: false});
    }
  }

  getTransactionMapping=(firstCall=false)=>{
    if(firstCall){
      this.setState({mappingLoader: true});
    }
    const {selectedBankAccount, selectedTransaction, propertySelected} = this.props;
    Autoload.HttpRequestAxios.HttpRequest(
      // With text qualifiers the IBAN no longer finds every mapping that fits — not a text-only
      // one, nor any for a payment without IBAN. Until the backend answers by transaction, all of
      // the property's mappings are loaded and handleGetMatchingMappings keeps those that fit.
      Autoload.Setting.finance_api_base_url + (TEXT_QUALIFIER_RULES_ENABLED ? `TransactionMappings/Property/${propertySelected.id}` : `TransactionMappings/Property/${propertySelected.id}/Iban/${selectedTransaction?.counterpartIban}`),
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleGetTransactionMapping',
      {firstCall},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handleGetTransactionMapping(response){
    const {selectedType} = this.state;
    const {selectedTransaction} = this.props;
    if(TEXT_QUALIFIER_RULES_ENABLED){
      this.handleGetMatchingMappings(response);
      return;
    }
    if(response.status && response.statuscode === 200){
      console.log('selectedTransaction?.transactionAssigments: ', selectedTransaction?.transactionAssigments);
      this.setState({selectedType: (response.result.length > 0 && response.result[0].transactionType	=== 'Rent') ? 'RENTAL_INCOME' : 'CREDIT_DEBIT_BALANCE', 
        mappings: response.result, 
        autoReceiptCreation: true, 
        autoReceiptCreationOldStatus: true, 
        isEarlyPaymentEnabled: selectedType === 'RENTAL_INCOME' ? (response.result.length > 0 ? response.result[0].isEarlyPaymentEnabled : false) : false,
        openAutoAssignReceiptTenantTransaction: response.other.firstCall ? selectedTransaction?.transactionAssigments ? false : true : false
      });
    }else if(response.statuscode === 400 && response.message === 'NOT_FOUND'){
      this.setState({mappings: [], autoReceiptCreation: false});
    }
    this.setState({mappingLoader: false});
  }

  // Keeps the loaded mappings that fit this payment. Several can share an IBAN (the Jobcenter
  // paying for several tenants, told apart only by the purpose), and the interim lookup loads
  // the whole property. Once the backend answers by transaction the filter keeps nothing out.
  handleGetMatchingMappings=(response)=>{
    const {selectedTransaction} = this.props;
    const found = response.status && response.statuscode === 200;
    if(!found && !(response.statuscode === 400 && response.message === 'NOT_FOUND')){
      this.setState({mappingLoader: false}, this.continuePendingSave);
      return;
    }
    const mappings = found ? selectMatchingMappings(response.result, selectedTransaction) : [];
    // Only on first load: afterwards the type at the top is the user's choice, and every save reloads.
    const takeTypeFromMappings = response.other.firstCall && mappings.length > 0 && this.state.selectedType === null;
    this.setState({
      mappings,
      mappingLoader: false,
      openAutoAssignReceiptTenantTransaction: response.other.firstCall && mappings.length > 0 && !selectedTransaction?.transactionAssigments,
      ...(takeTypeFromMappings && {selectedType: mappings[0].transactionType === 'Rent' ? 'RENTAL_INCOME' : 'CREDIT_DEBIT_BALANCE'}),
    }, ()=> {
      if(takeTypeFromMappings && this.state.selectedType === 'CREDIT_DEBIT_BALANCE'){
        this.getReceipts();
      }
      this.continuePendingSave();
    });
  }

  // A Speichern that waited for new rules goes on once the reload after creating them is in.
  continuePendingSave=()=>{
    const {saveWhenCreated, creatingMappings, draftMappings} = this.state;
    if(saveWhenCreated && creatingMappings.length === 0 && draftMappings.length === 0){
      this.setState({saveWhenCreated: false}, this.continueSave);
    }
  }

  deleteAllTransactionMapping=()=>{
    const {selectedBankAccount, selectedTransaction, propertySelected} = this.props;
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + `TransactionMappings/Property/${propertySelected.id}/Iban/${selectedTransaction?.counterpartIban}`,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteAllTransactionMapping',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handleDeleteAllTransactionMapping(response){
    // const {autoReceiptCreation, selectedType, selectedTenant, selectedReceipts} = this.state;
    // console.log('handleDeleteTransactionMapping: ', response);
    // if(autoReceiptCreation && selectedType && (selectedTenant.length > 0 || selectedReceipts.length > 0)){
    //   this.transactionMappingSetup();
    // }
    this.getTransactionMapping();
  }

  deleteTransactionMapping=(mappingId, eol=null)=>{
    const {selectedTransaction} = this.props;
    this.setState({mappingLoader: mappingId});
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + "TransactionMappings/" + mappingId,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteTransactionMapping',
      {eol, mappingId},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handleDeleteTransactionMapping(response){
    if(response.status && response.statuscode === 200){
      showNotification({
        message: 'Regel erfolgreich gelöscht.',
        icon: <img src={RedTick} alt='red-tick'/>,
        id: 'DeleteTrasactionMapping'
      });
      // A rule deleted before Speichern must not be deleted again on Abbrechen, nor offered
      // for existing transactions.
      const {[response.other.mappingId]: edit, ...conditionEdits} = this.state.conditionEdits;
      this.setState(({newCreatedMappings})=> ({conditionEdits, newCreatedMappings: newCreatedMappings.filter((id)=> id !== response.other.mappingId)}));
      this.getTransactionMapping();
    }else{
      showNotification({
        message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
        icon: <img src={RedCross} alt='red-cross'/>,
        id: 'DeleteTrasactionMappingError'
      });
      this.setState({mappingLoader: false});
    }

    if(response.other.eol){
      this.props.toggle();
    }
  }

  deleteTransactionReceiptAssignment=(receipts)=>{
    const {selectedTransaction} = this.props;

    receipts.map((receiptId, index)=> 
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + `ReceiptTenantTransactions/Transaction/${selectedTransaction?.id}/Receipt/${receiptId}`,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteTransactionReceiptAssignment',
      {eol: receipts.length === (index + 1), tenant: false},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    ));
  }

  deleteTransactionTenantAssignment=(tenantId)=>{
    const {selectedTransaction} = this.props;

    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + `ReceiptTenantTransactions/Transaction/${selectedTransaction?.id}/Tenant/${tenantId}`,
      'DELETE',
      null,
      null,
      false,
      true,
      false,
      this,
      'handleDeleteTransactionReceiptAssignment',
      {eol: true, tenant: true},
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handleDeleteTransactionReceiptAssignment(response){
    if(response.other.eol){
      if(response.other.tenant){
        if(response.status && response.statuscode === 200){
          this.handleAddTenantReceiptAssigment();
        }else{
          showNotification({
            message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
            icon: <img src={RedCross} alt='red-cross'/>
          });
        }
      }else{
        this.handleAddTenantReceiptAssigment();
      }
    }
  }

  handleAddTenantReceiptAssigment=()=>{
    const {edit, selectedTransaction, toggle} = this.props;
    const {selectedReceipts, selectedType, selectedTenant, autoReceiptCreation, autoReceiptCreationOldStatus} = this.state;

    if(edit){
      if(selectedType === 'CREDIT_DEBIT_BALANCE' && selectedReceipts?.length > 0){
        let newReceiptsToAdd= selectedTransaction?.transactionAssigments?.receiptIds?.length > 0 ? selectedReceipts.filter((id)=> selectedTransaction?.transactionAssigments.receiptIds.find((receiptId)=> receiptId === id) === undefined) : selectedReceipts;
        if(newReceiptsToAdd.length > 0){
          this.postTransactionReceiptAssignment(newReceiptsToAdd);
        }else{
          this.finishSave();
        }
      }else if(selectedType === 'RENTAL_INCOME' && selectedTenant.length > 0){
        this.postTransactionReceiptAssignment();
      }else{
        this.finishSave();
      }
    }else{
      this.postTransactionReceiptAssignment();
    }
  }

  handleAddReceiptModalOpen=(e)=>{
    //e.preventDefault();
    this.setState({addReceiptOpen: true});
  }

  openShow = (id, props) => {

    console.log('openShow: ', props);
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.rm_api_base_url + 'attachment/' + id,
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      '_handle_get_show_file',
      id,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  };
  
  _handle_get_show_file = (response) => {
    const {receiptsList} = this.state;
    if (response.status === false && response.message !== 'Not Found') {
      
    }

    if(response && response.result.includes('pdf')){
      fetch(Autoload.Setting.rm_api_base_url + 'attachment/' + response.other +'/download',
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': Autoload.Utils.getAuthToken()
        }
      })
            .then(response1 => {
                response1.blob()
                .then(blob => {
                  console.log('blob: ', blob)
                  let currentRecord = receiptsList.find((receipt)=> receipt.id === response.other);
                  console.log('currentRecord: ', currentRecord, response, receiptsList);
                  if(currentRecord){
                    this.setState({
                      currentRecord: { ...currentRecord, file_name: blob.size > 0 ? blob : '' },
                      showModal: true,
                    });
                  }else{
                    showNotification({
                      message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
                      icon: <img src={RedCross} alt='red-cross'/>
                    });
                  }})
                  var loader = document.getElementById('hello-housing-loader');
                  loader.style.display = 'none';
              })
    } else {
      let currentRecord = receiptsList.find((receipt)=> receipt.id === response.other);
      if(currentRecord){
        this.setState({
          currentRecord: { ...currentRecord, file_name: response.result != null ? response.result : '' },
          showModal: true,
        });
      }else{
        showNotification({
          message: 'Es ist ein Fehler aufgetreten. Bitte probieren Sie es erneut oder wenden Sie sich an den Support.',
          icon: <img src={RedCross} alt='red-cross'/>
        });
      }
      
      var loader = document.getElementById('hello-housing-loader');
      loader.style.display = 'none';
    }
  };

  getMappingTableHeader=()=>{
    const {selectedType} = this.state;
    return (
      <TableHead>
        {selectedType === 'CREDIT_DEBIT_BALANCE' ?
        <TableRow>
          <TableCell className='transaction-mapping-header'>Kostenart</TableCell>
          <TableCell className='transaction-mapping-header'>Steuerliche Kostenart</TableCell>
          <TableCell className='transaction-mapping-header'>MwSt.-Satz</TableCell>
          <TableCell/>
        </TableRow>
        :
        <TableRow>
          <TableCell className='transaction-mapping-header'>Mietername</TableCell>
          <TableCell className='transaction-mapping-header'>Einheit</TableCell>
          <TableCell className='transaction-mapping-header'>Zahlt vorfällig</TableCell>
          <TableCell/>
        </TableRow>}
      </TableHead>
    )
  }

  getMappingTableBody=()=>{
    const {selectedType, mappings, costTypes, tenants} = this.state;
    console.log('tenants: ', tenants);
    return(
      <TableBody>
        {mappings.map((mapping)=> 
        selectedType === 'CREDIT_DEBIT_BALANCE' ? 
        <TableRow //className={`transaction-mapping-cards transaction-mapping-row`}
        >
          {/* <TableCell className='banks-table-cell'>{costTypes.find((costType)=> costType.id === mapping.utilityBillingCostTypeId)?.costTypeName}</TableCell>
          <TableCell className='banks-table-cell'>{mapping.taxCostType}</TableCell>
          <TableCell className='banks-table-cell'>{`${mapping.taxRate}%`}</TableCell>
          <TableCell className='banks-table-cell'>
            <button onClick={()=> null} type="button" className="close delete-cost-position" aria-label="Close"><span aria-hidden="true">×</span></button>
          </TableCell> */}
          <TableCell>
            <span style={{fontFamily: 'Inter, sans-serif', fontSize: '12px'}}>Beleg erzeugen (<span className='transaction-mapping-capsules-receipts'>{costTypes.find((costType)=> costType.id === mapping.utilityBillingCostTypeId)?.costTypeName}</span>, <span className='transaction-mapping-capsules-receipts'>{mapping.taxCostType}</span>, <span className='transaction-mapping-capsules-receipts'>{mapping.taxRate}%</span>)</span>
          </TableCell>
        </TableRow>
        :
        <TableRow className={`transaction-mapping-cards transaction-mapping-row`}>
          <TableCell className='banks-table-cell'>{tenants.find((tenant)=> tenant.id === mapping.tenantId)?.name}</TableCell>
          <TableCell className='banks-table-cell'>{tenants.find((tenant)=> tenant.id === mapping.tenantId)?.rentalUnitName}</TableCell>
          <TableCell className='banks-table-cell'>{mapping.isEarlyPaymentEnabled ? <Tooltip label='Zahlt vorfällig'>{UtilityBillingAssignedIcon('#5555FF')}</Tooltip> : <Tooltip label='nicht früh bezahlt'>{UtilityBillingAssignedIcon('#9A9AB5')}</Tooltip>}</TableCell>
          <TableCell className='banks-table-cell'>
            <button onClick={()=> null} type="button" className="close delete-cost-position" aria-label="Close"><span aria-hidden="true">×</span></button>
          </TableCell>
        </TableRow>)}
      </TableBody>
    )
  }

  // Applies an edit to a mapping: a draft only changes locally, a saved mapping is saved.
  updateMapping=(mappingId, patch)=>{
    if(isDraftId(mappingId)){
      this.setState(({draftMappings})=> ({draftMappings: draftMappings.map((mapping)=> mapping.id === mappingId ? {...mapping, ...patch} : mapping)}));
      return;
    }
    const mappings = this.state.mappings.map((mapping)=> mapping.id === mappingId ? {...mapping, ...patch} : mapping);
    this.setState({mappings}, ()=> this.putTransactionMapping(mappingId));
  }

  handleMappingChange=(mappingId, field, selectedValue)=> this.updateMapping(mappingId, {[field]: selectedValue});

  removeMapping=(mappingId)=>{
    this.deleteTransactionMapping(mappingId);
    // let {mappings} = this.state;
    // mappings = mappings.filter((mapping)=> mapping.id !== mappingId);
    // this.setState({mappings}, ()=> this.deleteTransactionMapping(mappingId));
  }

  // The action half of a mapping — "Beleg erzeugen (…)" or "Mietzahlung erfassen (…)" — with
  // its inline menus. readOnly shows it without letting a menu open.
  // The action half of a mapping — "Beleg erzeugen" or "Mietzahlung erfassen" and its values,
  // each an inline menu. readOnly shows it without letting a menu open. The list reads it as
  // "Beleg erzeugen ( a, b, c )"; a card shows the values as capsules that wrap whole.
  renderMappingAction=(mapping, readOnly=false, inCard=false)=>{
    const {costTypes, tenants, openCostTypeMenu, taxCostTypes, openTaxCostTypeMenu, openTaxRateMenu, customTaxRate, openTenantMenu, openIsEarlyPaymentMenu, costTypeMenuOptionHover, heatingCostTypes, ruleTenantSearch, ruleShowOldTenants} = this.state;
    const tenantSearch = ruleTenantSearch.trim().toLowerCase();
    // The rule's own tenant stays listed even when it's a former one.
    const ruleTenants = tenants.filter((tenant)=> ruleShowOldTenants || tenant.out === '' || tenant.id === mapping.tenantId)
      .filter((tenant)=> !tenantSearch || `${tenant.name} ${tenant.rentalUnitName}`.toLowerCase().includes(tenantSearch));
    const expenditure = mapping.transactionType === 'Expenditure';
    const parts = expenditure ? [
      /* 1. COST TYPE MENU (Mantine v7) */
      <Menu key='costType' 
        closeOnItemClick={false}
        withinPortal={true} 
        zIndex={99999} 
        opened={openCostTypeMenu === mapping.id} 
        onChange={(opened) => {
          if (opened) {
            if (!readOnly) this.setState({openCostTypeMenu: mapping.id, stopToggle: true});
          } else {
            this.setState({openCostTypeMenu: false, stopToggle: false, costTypeMenuOptionHover: null});
          }
        }}
      >
        <Menu.Target>
          <div>
            <TruncatedTextHandler 
              truncate={true} 
              removePointerCursor={readOnly}
              alwaysEnableTooltip={true} 
              maxWidth={120} 
              alternateTooltipText={costTypes.find((costType)=> costType.id === mapping.utilityBillingCostTypeId) === undefined ? 'keine Angabe' : `Betriebskostenart: ${costTypes.find((costType)=> costType.id === mapping.utilityBillingCostTypeId)?.costTypeName} ${costTypes.find((costType)=> costType.id === mapping.utilityBillingCostTypeId && costType.costTypeIdentifier === 'HEATING_TOTAL') ? '('+mapping.heatingCostType+')' : ''}`} 
              className={costTypes.find((costType)=> costType.id === mapping.utilityBillingCostTypeId)?.costTypeName !== undefined ? 'transaction-mapping-capsules-receipts' : 'transaction-mapping-capsules-empty'} 
              text={costTypes.find((costType)=> costType.id === mapping.utilityBillingCostTypeId)?.costTypeName !== undefined ? costTypes.find((costType)=> costType.id === mapping.utilityBillingCostTypeId)?.costTypeName : 'Betriebskostenart'}/>
          </div>
        </Menu.Target>

        <Menu.Dropdown style={{ maxHeight: '200px', overflowY: 'auto' }}>
          <Menu.Item 
            style={{background: mapping.utilityBillingCostTypeId === null && '#e6e6ff', fontSize: '12px', fontStyle: 'italic'}} 
            styles={{itemLabel: {lineHeight: '15px'}}} 
            onClick={()=> this.setState({costTypeMenuOptionHover: null, openCostTypeMenu: false}, ()=> this.updateMapping(mapping.id, {utilityBillingCostTypeId: null, heatingCostType: null}))}>
            keine Angabe
          </Menu.Item>

          {costTypes.sort((a,b)=> a?.label?.toLowerCase().localeCompare(b?.label?.toLowerCase())).map((costType)=> (
            <Menu.Item 
              key={costType.id}
              style={{position: 'relative', background: costType.value === mapping.utilityBillingCostTypeId && '#e6e6ff', fontSize: '12px', whiteSpace: 'nowrap'}} 
              styles={{itemLabel: {lineHeight: '15px'}}} 
              onClick={(e)=> {
                if (costType.costTypeIdentifier !== 'HEATING_TOTAL') {
                  this.setState({costTypeMenuOptionHover: null, openCostTypeMenu: false}, ()=> this.updateMapping(mapping.id, {utilityBillingCostTypeId: costType.id, heatingCostType: null}));
                }else{
                  e.preventDefault();
                  e.stopPropagation();
                  this.setState({costTypeMenuOptionHover: mapping.id + '_HEATING_TOTAL'});
                }
              }}
            >
              {costType.label}
              
              {/* SUBMENU FOR HEATING_TOTAL */}
              {costType.costTypeIdentifier === 'HEATING_TOTAL' &&
                <Menu 
                  opened={costTypeMenuOptionHover === mapping.id + '_HEATING_TOTAL'} 
                  onChange={(opened) => {
                    if (opened) {
                      this.setState({stopToggle: true});
                    } else {
                      this.setState({ costTypeMenuOptionHover: null });
                      setTimeout(() => {
                        this.setState({ stopToggle: false });
                      }, 150);
                    }
                  }}
                  delay={500} 
                  withinPortal={true} 
                  zIndex={99999} 
                  position="right-start"
                >
                  <Menu.Target>
                    <div style={{position: 'absolute', right: 0, top: 0, height: '100%', width: '10px'}} />
                  </Menu.Target>
                  
                  <Menu.Dropdown>
                    {heatingCostTypes.map((heatingCostTypeObject)=> (
                      <Menu.Item 
                        key={heatingCostTypeObject.heatingCostTypeName}
                        style={{background: heatingCostTypeObject.value === mapping.heatingCostType && '#e6e6ff', fontSize: '12px'}} 
                        styles={{itemLabel: {lineHeight: '15px'}}} 
                        onClick={(e) => {
                          e.stopPropagation();
                          this.setState({costTypeMenuOptionHover: null, openCostTypeMenu: false}, ()=> this.updateMapping(mapping.id, {utilityBillingCostTypeId: costType.id, heatingCostType: heatingCostTypeObject.heatingCostTypeName}));
                        }}
                      >
                        {heatingCostTypeObject.label}
                      </Menu.Item>
                    ))}
                  </Menu.Dropdown>
                </Menu>
              }
            </Menu.Item>
          ))}
        </Menu.Dropdown>
      </Menu>,

      /* 2. TAX COST TYPE MENU (Mantine v7) */
      <Menu key='taxCostType' 
        withinPortal={true} 
        zIndex={99999} 
        opened={openTaxCostTypeMenu === mapping.id} 
        onChange={(opened) => {
          if (opened) {
            if (!readOnly) this.setState({openTaxCostTypeMenu: mapping.id, stopToggle: true});
          } else {
            this.setState({openTaxCostTypeMenu: false, stopToggle: false});
          }
        }}
      >
        <Menu.Target>
          <div>
            <TruncatedTextHandler 
              truncate={true} 
              removePointerCursor={readOnly}
              alwaysEnableTooltip={true}
              maxWidth={120} 
              alternateTooltipText={mapping.taxCostType === null ? 'keine Angabe' : `Steuerliche Kostenart: ${mapping.taxCostType}`} 
              className={mapping.taxCostType ? 'transaction-mapping-capsules-receipts' : 'transaction-mapping-capsules-empty'} 
              text={mapping.taxCostType ? mapping.taxCostType : 'steuerliche Kostenart'}/> 
          </div>
        </Menu.Target>
        <Menu.Dropdown style={{ maxHeight: '200px', overflowY: 'auto' }}>
          <Menu.Item style={{background: mapping.taxCostType === null && '#e6e6ff', fontSize: '12px', fontStyle: 'italic'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.handleMappingChange(mapping.id, 'taxCostType', null)}>keine Angabe</Menu.Item>
          {taxCostTypes.sort((a, b) => a.label.localeCompare(b.label)).map((taxCostType)=> <Menu.Item style={{background: taxCostType.label === mapping.taxCostType && '#e6e6ff', fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.handleMappingChange(mapping.id, 'taxCostType', taxCostType.label)}>{taxCostType.label}</Menu.Item>)}
        </Menu.Dropdown>
      </Menu>,

      customTaxRate ? 
      <span key='taxRate'>
        <NumericFormat 
          className='transaction-mapping-capsules-receipts'
          style={{maxWidth: '44px'}}
          value={mapping.taxRate}
          thousandSeparator="." 
          decimalSeparator=","
          suffix={'%'}
          placeholder='0%'
          decimalScale={0}
          onValueChange={(values, sourceInfo) => this.handleMappingChange(mapping.id, 'taxRate', values.floatValue)}
        />
      </span>
      :
      /* 3. TAX RATE MENU (Mantine v7) */
      <Menu key='taxRate' 
        withinPortal={true} 
        zIndex={99999} 
        opened={openTaxRateMenu === mapping.id} 
        onChange={(opened) => {
          if (opened) {
            if (!readOnly) this.setState({openTaxRateMenu: mapping.id, stopToggle: true});
          } else {
            this.setState({openTaxRateMenu: false, stopToggle: false});
          }
        }}
      >
        <Menu.Target>
          <div>
            <TruncatedTextHandler 
              truncate={false} 
              removePointerCursor={readOnly}
              alwaysEnableTooltip={true}
              maxWidth={120} 
              alternateTooltipText={mapping.taxRate === null ? 'keine Angabe' : `MwSt.-Satz: ${mapping.taxRate}`} 
              className={mapping.taxRate ? 'transaction-mapping-capsules-receipts' : 'transaction-mapping-capsules-empty'} 
              text={mapping.taxRate ? `${mapping.taxRate}%` : 'MwSt.-Satz'}/> 
          </div>
        </Menu.Target>
        <Menu.Dropdown style={{ maxHeight: '200px', overflowY: 'auto' }}>
          <Menu.Item style={{background: mapping.taxRate === null && '#e6e6ff', fontSize: '12px', fontStyle: 'italic'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.handleMappingChange(mapping.id, 'taxRate', null)}>keine Angabe</Menu.Item>
          <Menu.Item style={{background: mapping.taxRate === 19 && '#e6e6ff', fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.handleMappingChange(mapping.id, 'taxRate', 19)}>19%</Menu.Item>
          <Menu.Item style={{background: mapping.taxRate === 7 && '#e6e6ff', fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.handleMappingChange(mapping.id, 'taxRate', 7)}>7%</Menu.Item>
          <Menu.Item style={{fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.setState({customTaxRate: true})}>Andere</Menu.Item>
        </Menu.Dropdown>
      </Menu>,
    ] : [
      /* 4. TENANT MENU (Mantine v7) */
      <Menu key='tenant' 
        withinPortal={true} 
        zIndex={99999} 
        opened={openTenantMenu === mapping.id} 
        onChange={(opened) => {
          if (opened) {
            if (!readOnly) this.setState({openTenantMenu: mapping.id, stopToggle: true, ruleTenantSearch: '', ruleShowOldTenants: false});
          } else {
            this.setState({openTenantMenu: false, stopToggle: false});
          }
        }}
      >
        <Menu.Target>
          <div>
            <TruncatedTextHandler 
              truncate={true} 
              removePointerCursor={readOnly}
              alwaysEnableTooltip={true}
              maxWidth={140} 
              alternateTooltipText={tenants.find((tenant)=> tenant.id === mapping.tenantId) === undefined ? 'keine Angabe' : `Mieter: ${tenants.find((tenant)=> tenant.id === mapping.tenantId)?.label}`} 
              className={tenants.find((tenant)=> tenant.id === mapping.tenantId) !== undefined ? 'transaction-mapping-capsules-tenant' : 'transaction-mapping-capsules-empty'} 
              text={`${tenants.find((tenant)=> tenant.id === mapping.tenantId) !== undefined ? tenants.find((tenant)=> tenant.id === mapping.tenantId)?.label : 'Mieter'}`}/>
          </div>
        </Menu.Target>
        <Menu.Dropdown style={{ maxHeight: '260px', overflowY: 'auto' }}>
          <TextInput
            size="xs"
            placeholder="Suche nach Mieter oder Mieteinheit"
            value={ruleTenantSearch}
            onChange={(event)=> this.setState({ruleTenantSearch: event.currentTarget.value})}
            // Typing must not move the menu's keyboard focus to an item.
            onKeyDown={(event)=> event.stopPropagation()}
            style={{marginBottom: '4px'}}
            data-autofocus
          />
          <Menu.Item closeMenuOnClick={false} style={{fontSize: '12px', fontStyle: 'italic'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.setState({ruleShowOldTenants: !ruleShowOldTenants})}>
            {ruleShowOldTenants ? 'Ehemalige Mieter ausblenden' : 'Ehemalige Mieter einblenden'}
          </Menu.Item>
          {ruleTenants.map((tenant)=> <Menu.Item key={tenant.id} style={{background: tenant.value === mapping.tenantId && '#e6e6ff', fontSize: '12px', lineHeight: '15px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.handleMappingChange(mapping.id, 'tenantId', tenant.id)}>{tenant.label}</Menu.Item>)}
          {ruleTenants.length === 0 && <div style={{fontSize: '12px', color: '#727293', padding: '6px 10px'}}>Keine Mieter gefunden.</div>}
        </Menu.Dropdown>
      </Menu>,

      /* 5. EARLY PAYMENT MENU (Mantine v7) */
      <Menu key='earlyPayment' 
        withinPortal={true} 
        zIndex={99999} 
        opened={openIsEarlyPaymentMenu === mapping.id} 
        onChange={(opened) => {
          if (opened) {
            if (!readOnly) this.setState({openIsEarlyPaymentMenu: mapping.id, stopToggle: true});
          } else {
            this.setState({openIsEarlyPaymentMenu: false, stopToggle: false});
          }
        }}
      >
        <Menu.Target>
          <div>
            <TruncatedTextHandler 
              truncate={false}
              removePointerCursor={readOnly}
              maxWidth={130} 
              className={'transaction-mapping-capsules-receipts'} 
              text={mapping.isEarlyPaymentEnabled ? 'zahlt vorfristig' : 'zahlt regulär'}/> 
          </div>
        </Menu.Target>
        <Menu.Dropdown>
          <Menu.Item className='tooltips transaction-mapping-rental-payment-early-payment-false' style={{background: !mapping.isEarlyPaymentEnabled && '#e6e6ff', fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.handleMappingChange(mapping.id, 'isEarlyPaymentEnabled', false)}>{'zahlt regulär'}</Menu.Item>
          <Menu.Item className='tooltips transaction-mapping-rental-payment-early-payment-true' style={{background: mapping.isEarlyPaymentEnabled && '#e6e6ff', fontSize: '12px'}} styles={{itemLabel: {lineHeight: '15px'}}} onClick={()=> this.handleMappingChange(mapping.id, 'isEarlyPaymentEnabled', true)}>{'zahlt vorfristig'}</Menu.Item>
        </Menu.Dropdown>
      </Menu>,
    ];
    const verb = <span style={{fontWeight: '500', whiteSpace: 'nowrap'}}>{expenditure ? 'Beleg erzeugen' : 'Mietzahlung erfassen'}</span>;

    if(inCard){
      return (
        <Group gap={6} className='transaction-mapping-receipts-text' style={{minHeight: FIRST_ROW_HEIGHT}}>
          {verb}
          {parts}
        </Group>
      );
    }
    return (
      <Group gap={0} className='transaction-mapping-receipts-text'>
        {verb} (&nbsp;
        {parts.map((part, index)=> <React.Fragment key={index}>{index > 0 && ',\u00a0'}{part}</React.Fragment>)}
        &nbsp;)
      </Group>
    );
  }

  renderMappingData=(hideDeleteButton=false, filterMappings=[])=>{
    const {mappings, mappingLoader} = this.state;
    
    return(mappings.filter((mapping)=> filterMappings.length > 0 ? filterMappings.find((filterMapping)=> mapping.id === filterMapping) !== undefined : mapping)
      .map((mapping)=> 
    mapping.transactionType === 'Expenditure' ?
    <Group wrap="nowrap" justify="space-between" style={{width: '100%'}} className='tooltips transaction-mapping-item'>
      <div>
        {this.renderMappingAction(mapping, hideDeleteButton)}
      </div>
      {hideDeleteButton === false &&
      (mappingLoader === mapping.id ?
      <div>
        <Loader size={'xs'}/>
      </div>
      :
      <div>
        <MantineTooltip style={{height: '15px'}} zIndex={999999} label='Regel löschen'><button onClick={()=> this.removeMapping(mapping.id)} type="button" className="close delete-cost-position" aria-label="Close"><span aria-hidden="true">×</span></button></MantineTooltip>
      </div>
      )}
    </Group>
    :
    <Group wrap="nowrap" justify="space-between" style={{width: '100%'}}>
      {this.renderMappingAction(mapping, hideDeleteButton)}
      {hideDeleteButton === false &&
        (mappingLoader === mapping.id ?
        <div>
          <Loader size={'xs'}/>
        </div>
        :
        <div style={{maxWidth: '14px'}}>
          <MantineTooltip style={{height: '15px'}} zIndex={99999} label='Regel löschen'><button onClick={()=> this.deleteTransactionMapping(mapping.id)} type="button" className="close delete-cost-position" aria-label="Close"><span aria-hidden="true">×</span></button></MantineTooltip>
        </div>
        )}
    </Group>));
  }

  addMapping=()=>{
    const {selectedType} = this.state;
    const {selectedTransaction, propertySelected, accountData, selectedBankAccount} = this.props;
    let payload={
      accountId: accountData.accountId,
      propertyId: propertySelected.id,
      bankAccountId: selectedBankAccount.id,
      transactionType: selectedType === 'CREDIT_DEBIT_BALANCE' ? 200 : 100,
      counterpartIban: selectedTransaction?.counterpartIban,
      counterpartName:	selectedTransaction?.counterpartName,
      utilityBillingCostTypeId: null,
      taxCostType: null,
      taxRate: null,//selectedType === 'CREDIT_DEBIT_BALANCE' ? 19 : null,
      tenantId: null,
      isEarlyPaymentEnabled: false
    };
    this.postTransactionMapping([payload], true);
  }

  getCurrentBillingPeriod=()=>{
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.property_api_base_url +
      'currentBillingPeriod' +
      '?propertyId=' +
      this.props.propertySelected.id +
      '&offset=0&fetch=10',
      'GET',
      null,
      null,
      false,
      true,
      false,
      this,
      "handleGetCurrentBillingPeriodResponse",
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      }
    );
  }

  handleGetCurrentBillingPeriodResponse(response){
    if(response.status && response.statuscode === 200){
      this.setState({currentBillingPeriod: response.result});
    }
  }

  calculateVatUsingAmount =(value, vatPercent)=> {
    return value - (value / parseFloat(`${1 + (vatPercent / 100)}`));
  }

  autoAddReceipts=()=>{
    const {selectedTransaction, propertySelected} = this.props;
    const {mappings, currentBillingPeriod} = this.state;
    (TEXT_QUALIFIER_RULES_ENABLED ? this.getMappingsOfSelectedType() : mappings).map((mapping)=> {
      let netAmount = this.calculateVatUsingAmount(selectedTransaction?.amount, mapping.taxRate);
      let vatAmount = selectedTransaction?.amount - netAmount;

      console.log('autoAddReceipts: ', selectedTransaction?.amount, netAmount, vatAmount);
      const data = JSON.stringify({
        id: null,
        name: selectedTransaction?.counterpartName,
        receiptDate: `${dayjs(new Date(selectedTransaction?.bankBookingDate)).format('YYYY-MM-DD')}T00:00:00`,
        date: `${dayjs(new Date(selectedTransaction?.bankBookingDate)).format('YYYY-MM-DD')}T00:00:00`,
        costs: selectedTransaction?.amount,
        cost: selectedTransaction?.amount,
        utilityBillingRelevant: mapping.utilityBillingCostTypeId ? true : null,
        receiptPeriodStart: currentBillingPeriod?.startDate,
        receiptPeriodEnd: currentBillingPeriod?.endDate,
        propertyId: propertySelected.id,
        selectedCostTypes: mapping.utilityBillingCostTypeId ? [{ id: mapping.utilityBillingCostTypeId }] : [],
        //New attributes
        vatPercent: mapping.taxRate,
        vatAmount,
        netAmount,
        laborCost: null,
        taxCostType: mapping.taxCostType,
        receiptNumber: null,
        notes: selectedTransaction?.purpose
      });
      Autoload.HttpRequestAxios.HttpRequest(
        Autoload.Setting.rm_api_base_url + 'create',
        'POST',
        data,
        null,
        false,
        true,
        false,
        this,
        'handleAutoAddReceipt',
        null,
        false,
        '',
        {
          'Content-Type': 'application/json',
          Authorization: Autoload.Utils.getAuthToken(),
        }
      );
    });
  }

  handleAutoAddReceipt(response){
    const {selectedReceipts} = this.state;
    if(response.status && response.statuscode === 200){
      this.setState({selectedReceipts: [...selectedReceipts, response.result]},()=> this.getReceipts());
    }
  }

  autoAssignTenant=()=>{
    const {mappings} = this.state;
    const mapping = TEXT_QUALIFIER_RULES_ENABLED ? this.getMappingsOfSelectedType()[0] : mappings[0];
    if(mapping){
      this.setState({selectedTenant: [mapping.tenantId]});
    }
  }

  applyToAllPreviousTransactions=()=>{
    const {selectedBankAccount} = this.props;
    const {newCreatedMappings} = this.state;
    
    Autoload.HttpRequestAxios.HttpRequest(
      Autoload.Setting.finance_api_base_url + 'Transactions/BankAccount/'+ selectedBankAccount?.id+ `${newCreatedMappings.length > 0 ? newCreatedMappings.map((newCreatedMapping, index)=> `${index === 0 ? '?transactionMappingIds=' : '&transactionMappingIds='}${newCreatedMapping}`) : ''}`.replace(',', ''),
      'PUT',
      null,
      null,
      false,
      true,
      false,
      this,
      'handlePutApplyToAllPreviousTransactions',
      null,
      false,
      '',
      {
        'Content-Type': 'application/json',
        Authorization: Autoload.Utils.getAuthToken(),
      },
      true
    );
  }

  handlePutApplyToAllPreviousTransactions(response){
    // The new mappings go along so the list can refresh every transaction they may have just
    // assigned — with a text qualifier those aren't only the ones with this IBAN.
    this.setState({applyMappingToLegacyTransactions: false},()=> this.props.toggle(true, TEXT_QUALIFIER_RULES_ENABLED ? this.getNewCreatedMappings() : null));
  }
  
  renderMappingCard=(mapping, readOnly=false)=>{
    const {selectedTransaction} = this.props;
    const {mappingLoader, creatingMappings} = this.state;
    const draft = isDraftId(mapping.id);
    const edit = this.getConditionEdit(mapping);
    const error = getMappingConditionError(this.conditionFromEdit(edit, mapping), selectedTransaction);
    return (
      <TransactionMappingCard
      key={mapping.id}
      transactionType={mapping.transactionType}
      draft={draft}
      readOnly={readOnly}
      saving={mappingLoader === mapping.id || creatingMappings.includes(mapping.id)}
      onDelete={()=> draft ? this.discardDraftMapping(mapping.id) : this.removeMapping(mapping.id)}
      conditions={readOnly ?
        // Same first-row height as the editable fields, so "wenn" sits level with it.
        <div style={{display: 'flex', alignItems: 'center', minHeight: FIRST_ROW_HEIGHT}}><MappingConditionSummary mapping={mapping}/></div>
        :
        <MappingConditionFields
        iban={mapping.counterpartIban || selectedTransaction?.counterpartIban}
        counterpartName={selectedTransaction?.counterpartName}
        ibanChecked={edit.ibanChecked}
        textChecked={edit.textChecked}
        text={edit.text}
        // Not while an empty field is still being filled in — only once the user leaves it, or
        // types something that doesn't fit this payment.
        error={(edit.touched || edit.text.trim() !== '') ? error : null}
        onIbanChange={(ibanChecked)=> this.editMappingCondition(mapping, {ibanChecked}, true)}
        // Unticking drops the text and saves; ticking only opens the field for typing.
        onTextToggle={(textChecked)=> this.editMappingCondition(mapping, textChecked ? {textChecked} : {textChecked, text: ''}, !textChecked)}
        onTextChange={(text)=> this.editMappingCondition(mapping, {text})}
        onTextBlur={()=> this.editMappingCondition(mapping, {}, true)}
        />}
      action={this.renderMappingAction(mapping, readOnly, true)}
      />
    );
  }

  renderMappingCards=()=>{
    const {mappings, draftMappings, selectedType, creatingMappings} = this.state;
    return (
      <Stack gap={10} style={{width: '100%'}}>
        {(mappings.length === 0 && draftMappings.length === 0) &&
        <EmptyStateContainer
        heading={'Noch keine Regel für diese Zahlung angelegt.'}
        subheading={'Fügen Sie eine Regel hinzu, um ähnliche Zahlungen künftig automatisch zuzuordnen.'}
        icon={null}
        showBtn={false}
        styleMainContainer={{marginTop: 0}}
        />}
        {mappings.map((mapping)=> this.renderMappingCard(mapping))}
        {draftMappings.map((mapping)=> this.renderMappingCard(mapping))}
        {/* Disabled only while a rule is being created at once, so a double click can't create it twice. */}
        <AddMappingButton
        label={`Regel für ${selectedType === 'RENTAL_INCOME' ? 'Mieteinnahme' : 'Ausgabe'} hinzufügen`}
        onClick={this.addRuleMapping}
        disabled={creatingMappings.some((id)=> id.startsWith('new-'))}
        />
      </Stack>
    );
  }

  render() {
    const { open, toggle, className, selectedTransaction, edit, selectedBankAccount, transactionSection } = this.props;
    const { hover1, hover2, selectedType, isMobile, receiptsLoader, receiptsList, selectedReceipts, selectedTenant, selectReceiptsForTransactionAssigmentModalOpen, autoReceiptCreation, tenants, tenantsLoading, dropdownIcon, addReceiptOpen, ReceiptPage, rightSectionProps, showModal, ImageOpen, currentRecord, selectedMonth, dropdownIconForMonths, isEarlyPaymentEnabled, mappings, stopToggle, openAutoAssignReceiptTenantTransaction, openDeleteAllTransactionMappingConfirmationModal, mappingLoader, newCreatedMappings, openApplyMappingToLegacyTransactionsModal, hideOldTenants, aiSuggestedReceipt, draftMappings } = this.state;

    console.log('receiptsList: ', receiptsList);
    console.log('selectedReceipts_1234: ', selectedReceipts, receiptsList.filter((receipt)=> selectedReceipts.find((receiptId)=> receiptId === receipt.id) !== undefined));
    console.log('selectedTenant_1234: ', selectedTenant);

    console.log('tenants: ', tenants);

    console.log('edit: ', edit);

    console.log('selectedTransaction: ', selectedTransaction);
    console.log('stopToggle: ', stopToggle);

    console.log('newCreatedMappings: ', newCreatedMappings);
    return (
      <CustomModal
        heading={'Beleg zuordnen'}
        headingClassName={'assign-transaction-modal-heading'}
        modalTitleClassName={'assign-receipt-transaction-modal-heading tooltips'}
        open={open}
        toggle={() => {
          console.log('toggle');
          if(!stopToggle){
            toggle();
          }
        }}
        className={`${className}`}
        // Wider than the 502px default, so a rule card's condition and its action each fit on one line.
        style={{minWidth: isMobile ? 'auto' : '590px'}}
      >
        <Stack gap={20}>
          {/* Only offered on a fresh assignment. On an edit the user already decided what this
              transaction is, and re-suggesting invites overwriting a deliberate choice. */}
          {SHOW_AI_TRANSACTION_SUGGESTION && !transactionSection && !edit && this.renderAiSuggestion()}
          {!transactionSection &&
          <Stack gap={0}>
            <Group><span className='add-allocation-sub-headings'>Art der Zahlung</span></Group>
            {/* <Group grow wrap="nowrap" style={{margin: '20px 0px 5px'}}> */}
            <SimpleGrid cols={2} style={{margin: '20px 0px 5px'}}>
                  <CardSelection
                  title={'Ausgabe'}
                  subText={'Bei der Zahlung handelt es sich um eine Ausgabe oder Erstattung.'}
                  icon={ReceiptsIcon}
                  blueIcon={ReceiptsIconBlue}
                  hover={hover1}
                  hoverName={'hover1'}
                  selectedType={selectedType}
                  type={'CREDIT_DEBIT_BALANCE'}
                  disabled={false}
                  onClick={()=> this.setState({selectedType: 'CREDIT_DEBIT_BALANCE', openDeleteAllTransactionMappingConfirmationModal: !TEXT_QUALIFIER_RULES_ENABLED && mappings.length > 0}, ()=> this.getReceipts())}
                  handleMouseEnter={(hoverName)=> this.handleMouseEnter(hoverName)}
                  handleMouseLeave={(hoverName)=> this.handleMouseLeave(hoverName)}
                  isMobile={isMobile}
                  width={'100%'}
                  //typeError={typeError}
                  />
                  <CardSelection
                  title={'Mieteinnahme'}
                  subText={'Bei der Zahlung handelt es sich um eine Mietzahlung.'}
                  icon={RentIcon}
                  blueIcon={RentIconBlue}
                  hover={hover2}
                  hoverName={'hover2'}
                  selectedType={selectedType}
                  type={'RENTAL_INCOME'}
                  disabled={false}
                  onClick={()=> this.setState({selectedType: 'RENTAL_INCOME', openDeleteAllTransactionMappingConfirmationModal: !TEXT_QUALIFIER_RULES_ENABLED && mappings.length > 0})}
                  handleMouseEnter={(hoverName)=> this.handleMouseEnter(hoverName)}
                  handleMouseLeave={(hoverName)=> this.handleMouseLeave(hoverName)}
                  isMobile={isMobile}
                  width={'100%'}
                  //typeError={typeError}
                  />
            </SimpleGrid>
            {/* </Group> */}
          </Stack>}
            
            {selectedType === 'RENTAL_INCOME' &&
            <Stack>
                {!transactionSection &&
                <Group>
                    <span className='modal-sub-headings'>Mieter auswählen</span>
                </Group>}
                <Group grow>
                    <CustomMultiSelect
                    data={[
                      {value: 'showOldTenants', label: hideOldTenants ? 'Ehemalige Mieter einblenden' : 'Ehemalige Mieter ausblenden'},
                      ...tenants.filter((tenant)=> hideOldTenants ? tenant.out === '' : tenant)
                    ]}
                    value={selectedTenant}
                    label={'Mieter'}
                    onChange={(value)=> {
                      // One tenant only: CustomMultiSelect adds every click to the list, so a new
                      // pick replaces the old one. The "Ehemalige Mieter" option only toggles.
                      if(value?.includes('showOldTenants')){
                        this.setState({hideOldTenants: !hideOldTenants, stopToggle: true}, ()=> 
                          setTimeout(() => {
                            this.setState({stopToggle: false});  
                          }, 600)
                        );
                      }else{
                        this.setState({selectedTenant: (value || []).slice(-1)});
                        if(selectedTenant.length > 0){
                          this.setState({hideOldTenants: true});
                        }else{
                          this.setState({hideOldTenants: false});
                        }  
                      }
                    }}
                    rightSection={tenantsLoading ? <Loader size={'xs'}/> : <img src={dropdownIcon}/>}
                    valueComponent={(props)=> <Value {...props} type={'tenant'}/>}
                    itemComponent={SelectItem}
                    className='multi-select-bank-transactions-receipt-assignment'
                    placeholder="Suche nach Mieter oder Mieteinheit"
                    styles={{
                        disabled: { background: 'white', cursor: 'pointer' },
                        input: {opacity: 1},
                        rightSection: {marginRight: '10px'},
                        dropdown: {display: selectedTenant.length > 0 && 'none'}
                    }}
                    searchable
                    disabled={tenantsLoading}
                    onSearchChange={(query)=> {
                      if(query && query?.length > 0){
                        this.setState({hideOldTenants: false});
                      }else{
                        this.setState({hideOldTenants: true});
                      }
                    }}
                    onClick={()=> {
                      if(!tenantsLoading && tenants.length === 0){
                        showNotification({
                          message: 'Es wurden noch keine Mieter angelegt.',
                          icon: <img src={RedCross} alt='red-cross'/>
                        });
                      }
                      if(selectedTenant.length === 0){
                        this.setState({hideOldTenants: true})
                      }
                    }}
                    onBlur={()=> this.setState({hideOldTenants: false})}
                    //clearable
                    onDropdownOpen={()=> tenants.length > 0 && this.setState({dropdownIcon: Up})}
                    onDropdownClose={()=> tenants.length > 0 && this.setState({dropdownIcon: Down})}
                    zIndex={9999999}
                    //disabled={receiptsLoader}
                    />
                </Group>
                <Group grow>
                  {console.log('testing124: ',tenants.find((tenant)=> tenant.value === selectedTenant[0]), selectedTenant)}
                  <Select
                  placeholder="Wählen"
                  label="Mietmonat"
                  onChange={(value) => this.setState({ selectedMonth: value })}
                  data={
                    tenants.find((tenant) => tenant.value === selectedTenant[0])
                      ? tenants
                          .find((tenant) => tenant.value === selectedTenant[0])
                          ?.noOfMonthBetweenMoveInMoveOut.map((m) => ({
                            value: m.value,
                            label: m.label,
                          }))
                      : [
                          {
                            value: dayjs(selectedTransaction?.bankBookingDate).format('MMMM YYYY'),
                            label: dayjs(selectedTransaction?.bankBookingDate).format('MMMM YYYY'),
                          },
                        ]
                  }
                  
                  value={selectedMonth}
                  searchable
                  withCheckIcon={false}
                  rightSection={<img src={dropdownIconForMonths} alt="arrow" />}
                  onDropdownOpen={() => this.setState({ dropdownIconForMonths: Up })}
                  onDropdownClose={() => this.setState({ dropdownIconForMonths: Down })}
                  disabled={selectedTenant.length === 0}
                  comboboxProps={{ withinPortal: false, zIndex: 9999999 }}
                  classNames={{ option: 'assign-transaction-mantine-select-option', input: 'assign-transaction-modal-tenant-month-select-input' }}
                  renderOption={({ option, checked }) => (
                    <Group 
                      justify="space-between" 
                      style={{ 
                        width: '100%',
                        backgroundColor: checked ? '#e6e6ff' : 'transparent',
                        borderRadius: '4px',
                        height: '37px',
                        padding: '5px 10px'
                      }}
                    >
                      <span>{option.label}</span>
                    </Group>
                  )}
                />
                </Group>
            </Stack>}

            
            <Stack>
              {selectedType === 'CREDIT_DEBIT_BALANCE' &&
              <>
                <Group>
                    <span className='modal-sub-headings'>Beleg zuordnen</span>
                </Group>
                <Group justify="space-between" wrap="nowrap">
                  <Group grow style={{width: '100%'}}>
                    <CustomMultiSelect
                    data={receiptsList}
                    value={selectedReceipts}
                    onChange={(values)=> this.setState({selectedReceipts: values})}
                    rightSection={receiptsLoader ? <Loader size={'xs'}/> : 
                    <LaunchIcon 
                    style={{fontSize: '15px', color: selectedReceipts.length > 0 ? '#5555FF' : '#9A9AB5'}}
                    onClick={()=> rightSectionProps.onClick()}
                    />}
                    valueComponent={(props)=> <Value {...props} onClick={()=> rightSectionProps.onClick()}/>} //onClick={()=> this.openShow(props.value, props)}
                    wrapperProps={selectedReceipts.length === 0 && rightSectionProps}
                    className='multi-select-bank-transactions-receipt-assignment'
                    placeholder="Wählen"
                    styles={{
                        disabled: { background: 'white', cursor: 'pointer' },
                        input: {opacity: 1},
                        rightSection: {
                          marginRight: '5px', 
                          marginLeft: '5px',
                          backgroundColor: 'white', 
                          borderTop: '1px solid #ced4da', 
                          borderBottom: '1px solid #ced4da',
                        },
                        dropdown: {display: 'none'},
                        wrapper: {width: '100%'},
                        values: {marginRight: '20px'}
                    }}
                    disabled={receiptsLoader}
                    />
                  </Group>  
                  <IconButton 
                  aria-label="filter list"
                  onClick={this.handleAddReceiptModalOpen}
                  style={{
                  background: '#5655FE',
                  border: '1px solid #5555FF', 
                  boxShadow: '0 1px 2px 0 rgba(14, 14, 29, .06)', 
                  padding: '5px',
                  cursor: 'pointer',
                  opacity: 1
                  }}>
                    <AddIcon 
                    style={{
                      color: 'white',
                      fontSize: '15px'
                      }}/>
                  </IconButton>
                </Group>
              </>}
              {(!transactionSection && selectedType) &&
              <Stack style={{marginTop: '10px'}} gap={'10px'}>
                <Group><span className='add-allocation-sub-headings tooltips remember-setting-for-transaction-assignment'>{TEXT_QUALIFIER_RULES_ENABLED ? 'Regeln für diese Zahlung' : 'Regel merken'}</span></Group>
                {mappingLoader === true ?
                <Group wrap="nowrap" justify='center' style={{width: '100%'}}>
                  <Loader/>
                </Group>
                :
                TEXT_QUALIFIER_RULES_ENABLED ?
                this.renderMappingCards()
                :
                mappings.length === 0 &&
                <Group>
                    <SwitchContainer
                    switchText={selectedType === 'RENTAL_INCOME' ? <span>Einstellungen merken und für Zahlungen mit IBAN <span style={{fontWeight: '500'}}>{selectedTransaction?.counterpartIban}</span> zukünftig automatisch Mietzahlung erzeugen.</span> : <span>Einstellungen merken und für Zahlungen mit IBAN <span style={{fontWeight: '500'}}>{selectedTransaction?.counterpartIban}</span> zukünftig automatisch Belege erzeugen</span>}
                    checked={autoReceiptCreation}
                    onChange={()=> {
                      if(selectedTransaction?.counterpartIban){
                        this.setState({autoReceiptCreation: !autoReceiptCreation}, ()=> {
                          if(!autoReceiptCreation === true && (selectedReceipts.length > 0 || selectedTenant.length > 0)){
                            this.transactionMappingSetup(true);
                          }
                        });
                      }else{
                        showNotification({
                          message: 'Für Transaktionen ohne IBAN können keine Regeln erstellt werden.', 
                          icon: <img src={RedCross} alt='red-cross'/>,
                          id: 'noCounterIbanError'
                        });
                      }
                    }}
                    disabled={mappingLoader || (selectedType === 'CREDIT_DEBIT_BALANCE' ? selectedReceipts.length === 0 : selectedType === 'RENTAL_INCOME' ? selectedTenant.length === 0 : true) || selectedTransaction?.counterpartIban === null}
                    textClassName={'transaction-assigment-modal-remember-switch-label'}
                    />
                </Group>}

                {/* {(selectedType === 'RENTAL_INCOME' && autoReceiptCreation && selectedTenant.length > 0) &&
                <Group>
                    <SwitchContainer
                    switchText={<span>Vorfristige Mietzahlungen berücksichtigen.</span>}
                    checked={isEarlyPaymentEnabled}
                    onChange={()=> this.setState({isEarlyPaymentEnabled: !isEarlyPaymentEnabled})}
                    disabled={!autoReceiptCreation}
                    textClassName={'transaction-assigment-modal-early-payments-switch-label tooltips'}
                    />
                </Group>} */}

                {(!TEXT_QUALIFIER_RULES_ENABLED && autoReceiptCreation) &&
                <Group>
                  {/* <TableContainer>
                    <Table>
                      {this.getMappingTableHeader()}
                      {this.getMappingTableBody()}
                    </Table>
                  </TableContainer> */}
                  <Stack style={{width: '100%'}}>
                    {mappings.length > 0 &&
                    <>
                      <span className='transaction-mapping-pre-text'>Für Zahlungen mit IBAN <span style={{fontWeight: '500'}}>{`${selectedTransaction?.counterpartIban} (${selectedTransaction?.counterpartName})`}</span> wurden folgende Regeln angelegt:</span>
                      {this.renderMappingData()}
                    </>}
                    {selectedType === 'CREDIT_DEBIT_BALANCE' &&
                    <div>
                      {/* <ColorButton
                      text={'Weitere Regel hinzufügen'}
                      className='gray-btn'
                      onClick={()=> this.addMapping()}
                      /> */}
                      <Group wrap="nowrap" style={{fontSize: '14px', fontWeight: '400', color: '#5555FF', cursor: 'pointer', margin: '5px 0px'}} gap={3} onClick={()=> this.addMapping()}>
                        <span>Weitere Regel hinzufügen</span>
                        {/* <img src={RightArrowPartner} style={{marginTop: '2px', width: '12px'}}/> */}
                        <AddIcon style={{fontSize: '14px', color: '#5555FF', marginTop: '2px'}}/>
                      </Group>
                    </div>}
                  </Stack>
                </Group>}
              </Stack>}
            </Stack>
            <Group justify="space-between">
                <div>
                    <ColorButton
                    text={'Abbrechen'}
                    className='gray-btn'
                    onClick={()=> {
                      if(newCreatedMappings.length > 0){
                        newCreatedMappings.forEach((mappingId, index)=> this.deleteTransactionMapping(mappingId, newCreatedMappings.length === (index+1)));
                      }else{
                        toggle();
                      }
                    }}
                    />
                </div>
                <div>
                    <ColorButton
                    text={'Speichern'}
                    className='purple-btn'
                    onClick={this.handleSave}
                    // New rules alone are enough to save, without a receipt or tenant.
                    disabled={!edit && selectedReceipts.length === 0 && selectedTenant.length === 0 && !(TEXT_QUALIFIER_RULES_ENABLED && (newCreatedMappings.length > 0 || draftMappings.length > 0))}
                    //disabled={selectedType === 'RENTAL_INCOME' ? selectedTenant === null : selectedType === 'CREDIT_DEBIT_BALANCE' && selectedReceipts.length === 0}
                    />
                </div>
            </Group>
        </Stack>
        {selectReceiptsForTransactionAssigmentModalOpen &&
        <SelectReceiptsForTransactionAssigmentModal
        edit={edit}
        open={selectReceiptsForTransactionAssigmentModalOpen}
        toggle={()=> this.setState({selectReceiptsForTransactionAssigmentModalOpen: false})}
        selectedReceiptsFromParent={selectedReceipts}
        selectedTransaction={selectedTransaction}
        saveSelectedReceipts={(selectedReceipts)=> this.setState({selectedReceipts, selectReceiptsForTransactionAssigmentModalOpen: false})}
        getReceipts={(newAddedReceipt)=> {
          console.log('toggleAddReceiptModal: ', newAddedReceipt);
          if(newAddedReceipt){
            this.setState({selectedReceipts: [...selectedReceipts, newAddedReceipt.id]}, ()=> this.getReceipts());
          }else{
            this.getReceipts();
          }
        }}
        />}

        {addReceiptOpen && (
        <ReceiptDetailModal
          history={this.props.history}
          record={null}
          receiptPage={ReceiptPage}
          parent={this}
          className="add-edit-receipt-modal"
          edit={false}
          open={addReceiptOpen}
          toggle={(newAddedReceipt)=> {
            if(newAddedReceipt){
              this.setState({addReceiptOpen: false, selectedReceipts: [...selectedReceipts, newAddedReceipt.id]}, ()=> this.getReceipts());
            }else{
              this.setState({addReceiptOpen: false});
            }
            
          }}
          isMobile={isMobile}
          transactionAssigment={selectedTransaction}
          aiSuggestedReceipt={aiSuggestedReceipt}
        />
        )}

          {showModal &&
          <ShowModal
            //onEditClick={this.handleEditClick}
            onExpansionClick={()=> this.setState({ImageOpen: true})}
            record={currentRecord}
            className="show-receipt-modal"
            open={showModal}
            history={this.props.history}
            transactionAssigment={true}
            // toggle={this.toggleShowModal}
            closeShow={()=> this.setState({showModal: false, currentRecord: null})}
          />}
          {ImageOpen &&
          <ImageModal
            img={currentRecord && currentRecord.file_name !== '' ? currentRecord.file_name : Receipt}
            className="expandImageModal"
            open={ImageOpen}
            toggle={()=> this.setState({ImageOpen: false})}
          />}
          {openAutoAssignReceiptTenantTransaction &&
          <AutoAssignReceiptTenantTransaction
          renderMappingData={()=> TEXT_QUALIFIER_RULES_ENABLED ? this.getMappingsOfSelectedType().map((mapping)=> this.renderMappingCard(mapping, true)) : this.renderMappingData(true)}
          selectedTransaction={selectedTransaction}
          textQualifierRules={TEXT_QUALIFIER_RULES_ENABLED}
          open={openAutoAssignReceiptTenantTransaction}
          toggle={()=> this.setState({openAutoAssignReceiptTenantTransaction: false})}
          addNewReceiptTenantTransaction={()=> this.setState({openAutoAssignReceiptTenantTransaction: false},()=> selectedType === 'CREDIT_DEBIT_BALANCE' ? this.autoAddReceipts() : this.autoAssignTenant())}
          />}
          {openDeleteAllTransactionMappingConfirmationModal &&
          <DeleteAllTransactionMappingConfirmationModal
          open={openDeleteAllTransactionMappingConfirmationModal}
          toggle={()=> this.setState({openDeleteAllTransactionMappingConfirmationModal: false, selectedType: (mappings.length > 0 && mappings[0].transactionType	=== 'Rent') ? 'RENTAL_INCOME' : 'CREDIT_DEBIT_BALANCE'})}
          deleteAllMappings={()=> this.setState({openDeleteAllTransactionMappingConfirmationModal: false}, ()=> this.deleteAllTransactionMapping())}
          />}
          {openApplyMappingToLegacyTransactionsModal &&
          <ApplyMappingToLegacyTransactionsModal
          open={openApplyMappingToLegacyTransactionsModal}
          newCreatedMappings={newCreatedMappings}
          selectedTransaction={selectedTransaction}
          newMappings={TEXT_QUALIFIER_RULES_ENABLED ? this.getNewCreatedMappings() : null}
          bankAccountId={selectedBankAccount?.id}
          renderNewMappings={()=> TEXT_QUALIFIER_RULES_ENABLED ? this.getNewCreatedMappings().map((mapping)=> this.renderMappingCard(mapping, true)) : this.renderMappingData(true, newCreatedMappings)}
          toggle={(applyMappingToLegacyTransactions=false, cancel=false)=> cancel ? this.setState({openApplyMappingToLegacyTransactionsModal: false}) : this.setState({openApplyMappingToLegacyTransactionsModal: false, applyMappingToLegacyTransactions},()=> this.checkForDeletion())}
          />}
      </CustomModal>
    );
  }
}

const mapStateToProps = (state) => {
    return {
      propertySelected: state.generalReducer.property,
      accountData: state.generalReducer.accountData,
      // For the AI suggestion call, which needs the encrypted token and user id the agent
      // server authenticates with — same source the messaging editor's AI modal uses.
      profileData: state.generalReducer.profile
    };
  };
  
export default connect(mapStateToProps)(AssignTransactionModal);
